function SearchParentsFor(start, cls, top) {
    var result;

    var parent = start.parentNode;
    if ((parent) && (parent.getAttribute)) {
        var pcls = parent.getAttribute("class");
        if (pcls) {
            var pclsArray = pcls.split(" ");
            for (var i = 0; i < pclsArray.length; i++) {
                if (pclsArray[i] == cls) {
                    result = parent;
                    break;
                }
            }
        }

        if ((!result) && ((!top) || (parent != top))) {
            result = SearchParentsFor(parent, cls, top);
        }
    }

    return (result);
}

function ParseQP() {
    var qpd = {};
    var qp = window.location.search.substr(1);
    var pairs = qp.split("&");

    for (var i = 0; i < pairs.length; i++) {
        var tuple = pairs[i].split("=");
        if ((tuple) && (tuple.length == 2)) {
            var key = tuple[0];
            var val = tuple[1];
            qpd[key] = decodeURIComponent(val);
        }
    }

    return (qpd);
}

function SendAPIRequest(url, method, payload, cb) {
    var xhr = new XMLHttpRequest();

    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            //console.log( "rx response " + xhr.responseText );
            var response;
            var err;
            if (xhr.status == 200) {
                if ((xhr.responseText) && (xhr.responseText.length > 0)) {
                    try {
                        response = JSON.parse(xhr.responseText);
                    } catch (e) {
                        console.log("error parsing response : " + e.stack);
                        err = {"error": e};
                    }
                }
            } else {
                err = {"error": xhr.status};

                if ((xhr.responseText) && (xhr.responseText.length > 0)) {
                    try {
                        err.detail = JSON.parse(xhr.responseText);
                    } catch (e) {
                    }
                }
            }

            cb(err, response, xhr);
        }
    };


    if ((method != "GET") && (payload)) {
        xhr.open(method, url, true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send(JSON.stringify(payload));
    } else {
        if (payload) {
            var qpStr = "?";
            for (var key in payload) {
                if (qpStr.length > 1) {
                    qpStr += "&";
                }
                qpStr += key + "=" + encodeURIComponent(payload[key]);
            }
            xhr.open(method, url + qpStr, true);
        } else {
            xhr.open(method, url, true);
        }

        xhr.send();
    }
}

function RC_BaseURL() {
    var rcb = window.location.href.toLowerCase();
    var marker = "/tools/recurring/portal/";
    var markerEnd = rcb.indexOf(marker) + marker.length;
    var hashEnd = rcb.indexOf("/", markerEnd);
    return (rcb.substr(0, hashEnd));
}

function AddrCat(str, address, field) {
    var result = str;
    var part = address[field];

    if ((part) && (part.length > 0)) {
        if (str.length > 0) {
            result += ", ";
        }
        result += part;
    }

    return (result);
}

function AddressString(address) {
    var result = AddrCat("", address, "address1");

    result = AddrCat(result, address, "address2");
    result = AddrCat(result, address, "city");
    result = AddrCat(result, address, "zip");

    return (result);
}

function NextOrderAddress(response, entry) {
    var addressLookup = {};
    var address = "";

    response.addresses.forEach(function (address) {
        if (addressLookup[address.id] == undefined) {
            addressLookup[address.id] = AddressString(address);
        }
    });

    var addressID = entry.orders[0].charge.address_id;
    if (addressLookup[addressID]) {
        address = addressLookup[addressID];
    }

    return (address);
}

function NextOrderPrice(response, entry) {
    var price = 0;
    var charges = [];

    entry.orders.forEach(function (order) {
        if (!charges.includes(order.charge.id) && order.is_skipped == false) {
            price = price + Number(order.charge.total_price);
            charges.push(order.charge.id);
        }
    });
    price = new Intl.NumberFormat('en-GB', {style: 'currency', currency: entry.orders[0].charge.currency}).format(price);

    return (price);
}

function NextOrderSubtotalPrice(response, entry) {
    var price = 0;
    var charges = [];

    entry.orders.forEach(function (order) {
        if (!charges.includes(order.charge.id) && order.is_skipped == false) {
            price = price + Number(order.charge.subtotal_price);
            charges.push(order.charge.id);
        }
    });
    price = new Intl.NumberFormat('en-GB', {style: 'currency', currency: entry.orders[0].charge.currency}).format(price);

    return (price);
}

function NextOrderShipping(response, entry) {
    var price = 0;
    var charges = [];
    var shippingDesc = "";

    entry.orders.forEach(function (order) {
        if (!charges.includes(order.charge.id) && order.is_skipped == false) {
            price = price + Number(order.charge.shipping_lines[0].price);
            shippingDesc = order.charge.shipping_lines[0].description;
            charges.push(order.charge.id);
        }
    });
    price = new Intl.NumberFormat('en-GB', {style: 'currency', currency: entry.orders[0].charge.currency}).format(price);

    return (shippingDesc + " " + price);
}

function NextOrderDiscount(response, entry) {
    var price = 0;
    var charges = [];

    entry.orders.forEach(function (order) {
        if (!charges.includes(order.charge.id) && order.is_skipped == false) {
            price = price + Number(order.charge.total_discounts);
            charges.push(order.charge.id);
        }
    });
    price = new Intl.NumberFormat('en-GB', {style: 'currency', currency: entry.orders[0].charge.currency}).format(price);

    return (price);
}

function NextOrderPaymentDetails(response, order) {
    var addressID = order.orders[0].charge.address_id;
    var paymentLast4 = "";

    response.addresses.forEach(function (address) {
        if (address.id == addressID) {
            paymentLast4 = address.include.payment_methods[0].payment_details.last4;
        }
    });

    return (paymentLast4);
}

function ShowNextOrderDetails(response, entry) {
    var when = new Date(entry.date);

    document.querySelector("#recharge-subscription-portal-v2 #renewalDateString").innerHTML = when.toLocaleDateString();
    document.querySelector("#recharge-subscription-portal-v2 #renewalDateInput").classList.add("hide");
    document.querySelector("#recharge-subscription-portal-v2 #editRenewalDateBtn svg").classList.add("hide");
    document.querySelector("#recharge-subscription-portal-v2 #editRenewalDateBtn span").classList.remove("hide");
    var userTimezoneOffset = when.getTimezoneOffset() * 60000;
    document.querySelector("#recharge-subscription-portal-v2 #renewalDateInput").value = new Date(when.getTime() - userTimezoneOffset).toISOString().split("T")[0];
    document.querySelector("#recharge-subscription-portal-v2 #addressString").innerHTML = NextOrderAddress(response, entry);
    document.querySelector("#recharge-subscription-portal-v2 #editAddressBtn span").classList.remove("hide");
    document.querySelector("#recharge-subscription-portal-v2 #editPaymentDetailsBtn span").classList.remove("hide");
    // document.querySelector( "#recharge-subscription-portal-v2 #priceToPay" ).innerHTML = NextOrderPrice( response, entry );
    document.querySelector("#recharge-subscription-portal-v2 #nextOrderDetailsString").innerHTML = NextOrderPrice(response, entry);
    document.querySelector("#recharge-subscription-portal-v2 #nextOrderPaymentString").innerHTML = "Ending in " + NextOrderPaymentDetails(response, entry);
    ShowAppliedDiscounts(entry);

    // TO DO : finish setting details in the right sidebar
    console.log("TO DO : Finish setting next order details in the right sidebar");

    g_entry = entry;

    entry.orders.forEach(function (order) {
        CreateSubscriptionRowForUpcomingOrderDetails(entry, order);
    });
    document.querySelector(".nod-total-details [data-nod-total-price]").innerHTML = NextOrderPrice(response, entry);
    document.querySelector(".nod-details [data-nod-sub-total-price]").innerHTML = NextOrderSubtotalPrice(response, entry);
    document.querySelector(".nod-details [data-nod-shipping]").innerHTML = NextOrderShipping(response, entry);
    document.querySelector(".nod-details [data-nod-date]").innerHTML = when.toLocaleDateString();

    if (!NextOrderDiscount(response, entry).includes("0.00")) {
        document.querySelector(".nod-details [data-nod-discounts]").innerHTML = NextOrderDiscount(response, entry);
        document.querySelector(".nod-details [data-nod-discount-row]").classList.remove("hide");
    }

}

function TemplateReplace(template, data) {
    var result = "";
    var src = template;
    var idx = 0;
    var length = src.length;
    while (idx < length) {
        var start = src.indexOf("{{", idx);
        if (start < 0) {
            result += src.substr(idx);
            break;
        }
        var tokenStart = start + 2;
        var end = src.indexOf("}}", tokenStart);
        if (end < 0) {
            result += src.substr(idx);
            break;
        }

        var chars = end - tokenStart;
        var token = src.substr(tokenStart, chars).trim();
        var replacement = data[token];

        try {
            replacement = decodeURIComponent(escape(replacement));
        } catch (e) {
            console.log(e);
        }

        result += src.substr(idx, start - idx);
        result += replacement;

        idx = end + 2;
    }
    return (result);
}

function CreateSubscriptionRow(entry, order, reasons) {
    var skeleton = `
    <div id="rc_subscription_card_element" class="flex-start-row rc_subscription_card_element_wrapper rc_subscription_container" data-subscription-status="{{ subscription_status }}">
        <div class="rc_photo_container">
            <img src="{{image_url}}" alt="{{image_alt}}">
        </div>
        <div class="rc_subscription_info">
            <div class="subscription_badge" style="background-color:{{status_colour}}" data-budgetype="{{subscription_status_text}}">
                {{subscription_status_text}}
                <span class="subscription_order_date">{{ order_schedule_date }}</span>
            </div>
      
            <div class="rc_order_title_container">
                {{product_title}}
            </div>
            <div class="flex-row-no-gap rc_order_price_details_container">
        
                <div>
                    <p class="product__variant" data-shopify-id="{{variant_id}}" data-parent-id="{{product_id}}">{{variant_title}}</p>
                    <!--
                     <select data-parent-id="{{product_id}}" data-sub-id="{{subscription_id}}" data-product-name="{{product_title}}" class="variantDropdown">
                           <option data-shopify-id="{{variant_id}}" data-parent-id="{{product_id}}">{{variant_title}}</option>
                     </select>
                     -->
                </div>
        
                <div class="hide">
                    <p class="product__price">
                        {{product_price_str}}
                    </p>
                </div>
                <div>
                    <p id="subtotalPrice__{{subscription_id}}" data-quantity="1" data-unit-price="{{product_price}}" class="subtotal__price">{{product_price_str}}</p>
                </div>
            </div>
       
            <div class="flex-start-row subscriptions_quantity_frequency_wrapper">
                <div class= "product__button-wrapper" >
                    <div class="flex-start-row product__quantity--wrapper">
                        <p clas="quantity" >QTY</p>
                        <button class="quantity--minus quantity_minus" aria-label="quantity minus">
                            <svg xmlns="http://www.w3.org/2000/svg" width="13.538" height="2" viewBox="0 0 13.538 2">
                                <g id="Group_2909" data-name="Group 2909" transform="translate(1 1)">
                                    <line id="Line_31" data-name="Line 31" x1="11.538" transform="translate(0)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></line>
                                </g>
                            </svg>
                        </button>
                        <input type="number"  name="quantity" aria-label="quantity" value="{{ product_quantity }}" id="{{subscription_id}}_quantity" class="quantity__input js-qty__num qty__input--{{subscription_id}}" data-sub-id="{{subscription_id}}">
                        <button class="quantity--plus quantity_plus" aria-label="quantity plus"> 
                            <svg xmlns="http://www.w3.org/2000/svg" width="13.538" height="13.538" viewBox="0 0 13.538 13.538">
                                <g id="Group_2909" data-name="Group 2909" transform="translate(1 1)">
                                    <line id="Line_30" data-name="Line 30" y2="11.538" transform="translate(5.769 0)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></line>
                                    <line id="Line_31" data-name="Line 31" x1="11.538" transform="translate(0 5.769)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></line>
                                </g>
                            </svg>
                        </button>
                    </div>
                </div>
                <div class="flex-start-row frequency__wrapper" data-sub-id="{{subscription_id}}">
                <span class="deliveryString freqBtnMobile" id="freqBtnMobile">Every 
                    <span id="intervalCount" class="intervalCount hide" data-count="6">6</span>
                    <span id="frequencyInterval" class="frequencyInterval hide">weeks</span>
                </span>
                <a class="mobile-hide freqBtn hide" id="freqBtn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30.05" height="30.05" viewBox="0 0 30.05 30.05">
                      <g id="Group_5009" data-name="Group 5009" transform="translate(-1049.225 -765.975)">
                        <circle id="Ellipse_10" data-name="Ellipse 10" cx="15.025" cy="15.025" r="15.025" transform="translate(1079.274 765.975) rotate(90)" fill="#025156"></circle>
                        <g id="Group_5008" data-name="Group 5008" transform="translate(-34.734 1.026)">
                          <path id="Path_4340" data-name="Path 4340" d="M43.042,1.859,41.434.251a.911.911,0,0,0-1.255,0l-.879.878,2.863,2.863.879-.878a.889.889,0,0,0,0-1.255" transform="translate(1062.665 773)" fill="#fff"></path>
                          <path id="Path_4341" data-name="Path 4341" d="M14.241,22.809v1.534l.576.384,7.27-7.262-1.252-1.25Z" transform="translate(1081.37 760.897)" fill="#fff"></path>
                          <path id="Path_4342" data-name="Path 4342" d="M7.155,17.707l6.594-6.593L12.494,9.861,5.229,17.119l.392.589Z" transform="translate(1088.097 765.64)" fill="#fff"></path>
                          <path id="Path_4343" data-name="Path 4343" d="M35.3,6.518,38.163,9.38l.654-.653L35.954,5.863Z" transform="translate(1065.652 768.624)" fill="#fff"></path>
                          <path id="Path_4344" data-name="Path 4344" d="M4.945,42.681V41.16H3.424a.254.254,0,0,1-.211-.113l-.3-.446-.449,1.525,1.5,1.5L5.49,43.18l-.432-.288a.254.254,0,0,1-.113-.211" transform="translate(1090.159 742.694)" fill="#fff"></path>
                          <path id="Path_4345" data-name="Path 4345" d="M0,50.375l1.573-.462L.463,48.8Z" transform="translate(1092 736.572)" fill="#fff"></path>
                        </g>
                      </g>
                     </svg>
                </a>
                <input type="hidden" value="week" id="order_interval_unit-{{address_id}}">
                <input type="hidden" value="6" id="order_interval_frequency-{{address_id}}">
                <input type="hidden" value="6" id="charge_interval_frequency-{{address_id}}">
                <select class="freqDropdown" id="freqDropdwon-{{address_id}}" data-address-id="{{address_id}}">
                     <option data-value="1" value="1">1 Week</option>
                     <option data-value="2" value="2">2 Weeks</option>
                     <option data-value="3" value="3">3 Weeks</option>
                     <option data-value="4" value="4">4 Weeks</option>
                     <option data-value="5" value="5">5 Weeks</option>
                     <option data-value="6" value="6">6 Weeks</option>
                     <option data-value="7" value="7">7 Weeks</option>
                     <option data-value="8" value="8">8 Weeks</option>
                     <option data-value="9" value="9">9 Weeks</option>
                     <option data-value="10" value="10">10 Weeks</option>
                     <option data-value="11" value="11">11 Weeks</option>
                     <option data-value="11" value="12">12 Weeks</option>
                     <option data-value="52" value="52">52 Weeks</option>
                </select>
            </div>
        </div> 
        <button class="rc_btn hide" id="save_subscription_btn" data-sub-id="{{subscription_id}}">
            <span>Save Changes</span>
        </button>   
    
        <div class="flex-start-row subscription-action__wrapper">
            <button data-title="Cancel" id="subscription_cancel_btn"class="rc_product-btnrc_product-btn rc_btn text-uppercase text-center cancel-this"> Cancel </button>
            <button id="subscription_skip" class="rc_product-btn rc_btn text-uppercase text-center" data-id="{{subscription_id}}" data-date="{{order_date}}" 
                data-current-date="{{current_date}}" data-unit="week" data-frequency="{{subscription_frequency}}" data-type="skip" style="display: inline-block" data-address-id="{{address_id}}"> Skip
            </button>
            <button id="subscription_unskip" class="rc_product-btn rc_btn text-uppercase text-center hide" data-id="{{subscription_id}}" data-type="unskip" 
                style="display: inline-block" data-address-id="{{address_id}}"> Unskip
            </button>
            <div id="product_remove_Popup">
                <div class="product_remove_Popup_inner">
                    <span id="cancel_popup_close_btn">&#10005;</span>
                    <label for="product_remove_reason_dropdown-{{subscription_id}}">Why are you cancelling today?</label>
                     <select name="product_remove_reason_dropdown-{{subscription_id}}" id="product_remove_reason_dropdown" data-liquid="{{ settings.show_breadcrumbs }}" required>
                          <option selected value="" disabled>Select Option</option>
                          {{ cancelreasonsHTMl }}
                    </select>  
                    <p class="error_message hide">Please select Why are you cancel?</p>
                    <label for="product_remove_reason-{{subscription_id}}">Anything we could do better?</label>
                    <textarea  name="product_remove_reason-{{subscription_id}}" id="product_remove_reason" value="" required rows="2" cols="50" required></textarea>
                    <button data-title="Cancel" id="subscription_cancel" data-id="{{subscription_id}}" data-address-id="{{address_id}}" data-unit="week" class="rc_product-btnrc_product-btn rc_btn text-uppercase text-center popup_btn">
                        Submit 
                    </button>
                    
                </div>
            </div>
        </div>
    </div>
    `;

    var subscription_badge_text = "";
    var subscription_badge_colour = "";
    if (order.subscription.status == "ACTIVE") {
        subscription_badge_text = "Subscription";
        subscription_badge_colour = "#b3ccea";
    } else if (order.subscription.status == "ONETIME") {
        subscription_badge_text = "One-off";
        subscription_badge_colour = "#ccb2d0";
    }
    if (order.charge.status == "SKIPPED") {
        subscription_badge_text = "Subscription";
        subscription_badge_colour = "#b3ccea";
    }

    var dateString = '';
    if(entry.date) {
        var dateString = new Date(entry.date);
        dateString = new Intl.DateTimeFormat('en-gb').format(dateString);
    }

    var data = {
        "image_url": order.subscription.product.shopify_details.image.src,
        "image_alt": order.subscription.product.shopify_details.image.alt,
        "product_id": order.subscription.shopify_product_id,
        "subscription_id": order.subscription.id,
        "product_title": order.title,
        "variant_id": order.subscription.shopify_variant_id,
        "variant_title": order.subscription.variant_title,
        "product_price_str": order.subscription.price,
        "product_price": order.subscription.price,
        "product_quantity": order.subscription.quantity,
        "address_id": order.charge.address_id,
        "order_date": new Date(entry.when),
        "subscription_frequency": order.subscription.order_interval_frequency,
        "subscription_status_text": subscription_badge_text,
        "status_colour": subscription_badge_colour,
        "subscription_status": order.subscription.status,
        "is_skipped": order.is_skipped,
        "order_schedule_date": dateString,
        "cancelreasonsHTMl": reasons.innerHTML,
    };

    var markup = TemplateReplace(skeleton, data);
    var wrapper = document.createElement("div");
    wrapper.setAttribute("class", "rc_active_subscription_container");
    wrapper.innerHTML = markup;

    // AddVariantOptions( wrapper, order );
    SetSkipUnskip(wrapper, order);
    SetFrequency(wrapper, order);
    // SetProductPrices(entry);
    return (wrapper);

}


function CreateSubscriptionRowForUpcomingOrderDetails(entry, order) {
    var skeleton = '<div class="nod-order-row">' + '<div class="nod-order-col nod-order-col-img">' + '<img />' + '</div>' + '<div class="nod-order-col nod-order-col-body">' + '<h5 data-product-title></h5>' + '<p data-variant-title></p>' + '</div>' + '<div class="nod-order-col nod-order-col-price">' + '<p data-price></p>' + '</div>' + '</div>';
    if(order.is_skipped){
        return;
    }

    var parent = document.querySelector(".nod-products");
    var copy = ConvertStringToHTML(skeleton);

    var img = copy.querySelector("img");
    var titleEl = copy.querySelector("[data-product-title]");
    var variantEl = copy.querySelector("[data-variant-title]");
    var priceEl = copy.querySelector("[data-price]");

    img.setAttribute("src", order.subscription.product.shopify_details.image.src);
    img.setAttribute("alt", order.subscription.product.shopify_details.image.alt);

    titleEl.innerText = order.title;
    variantEl.innerText = order.subscription.variant_title;
    priceEl.innerText = new Intl.NumberFormat('en-GB', {style: 'currency', currency: entry.orders[0].charge.currency}).format(Number(order.subscription.price))
    parent.appendChild(copy);
}

function SetSkipUnskip(wrapper, order) {
    var actionsWrapper = wrapper.querySelector(".subscription-action__wrapper");
    var skipButton = actionsWrapper.querySelector("#subscription_skip");
    var unskipButton = actionsWrapper.querySelector("#subscription_unskip");
    if (skipButton && unskipButton && order.is_skipped && order.is_skipped == true) {
        skipButton.classList.add("hide");
        unskipButton.classList.remove("hide");
    }
}

function SetFrequency(wrapper, order) {
    var target = wrapper.querySelector(".freqDropdown");

    for (var i = 0; i < target.options.length; i++) {
        if (target.options[i].value == order.subscription.order_interval_frequency) {
            target.selectedIndex = i;
            break;
        }
    }
}

function AddVariantOptions(wrapper, order) {
    var shopifyProduct = order.subscription.product.shopify_details;
    var target = wrapper.querySelector(".variantDropdown");

    shopifyProduct.variants.forEach(function (variant) {
        var option = document.createElement("option");
        option.setAttribute("data-shopify-id", variant.id);
        option.setAttribute("data-parent-id", order.shopify_product_id);
        option.appendChild(document.createTextNode(variant.title));
        target.appendChild(option);
    });
}

function SetProductPrices(entry) {
    var subscriptionSubTotals = document.querySelectorAll('#recharge-subscription-portal-v2 .subtotal__price');

    for (var i = 0; i < subscriptionSubTotals.length; i++) {
        subscriptionSubTotals[i].innerHTML = formatter.format(parseFloat(subscriptionSubTotals[i].dataset.quantity * subscriptionSubTotals[i].dataset.unitPrice, 10));
        // subscriptionSubTotals[i].innerHTML = new Intl.NumberFormat('en-GB', {style: 'currency', currency: entry.orders[0].charge.currency}).format(parseFloat(subscriptionSubTotals[i].dataset.quantity * subscriptionSubTotals[i].dataset.unitPrice, 10))
    }
}

function HandleOnetimeMarkup() {
    var elements = document.querySelectorAll("#recharge-subscription-portal-v2 #rc_subscription_card_element");
    for (var i = 0; i < elements.length; i++) {
        if (elements[i].dataset.subscriptionStatus == "ONETIME") {
            var frequencyWrapper = elements[i].querySelector(".frequency__wrapper");
            frequencyWrapper.parentNode.removeChild(frequencyWrapper);
            var skipWrapper = elements[i].querySelector(".subscription-action__wrapper #subscription_skip");
            skipWrapper.parentNode.removeChild(skipWrapper);
            var unskipWrapper = elements[i].querySelector(".subscription-action__wrapper #subscription_unskip");
            unskipWrapper.parentNode.removeChild(unskipWrapper);
            var cancelButton = elements[i].querySelector(".subscription-action__wrapper #subscription_cancel");
            cancelButton.setAttribute("id", "onetime_cancel");
            // elements[ i ].querySelector( ".quantity__input" ).style.pointerEvents = "none";
            elements[i].querySelector(".cancel-this").style.display = "none";
        }
    }
}

function HandleLoadingOverlay(display) {
    var overlay = document.querySelector("#recharge-subscription-portal-v2 #loading-overlay");

    if (display == "show") {
        if (overlay.classList.contains("hide")) {
            document.querySelector("#recharge-te").style.zIndex = 999999;
            overlay.classList.remove("hide");
        }
    } else if (display == "hide") {
        if (!overlay.classList.contains("hide")) {
            document.querySelector("#recharge-te").style.zIndex = 100000;
            overlay.classList.add("hide");
        }
    }
}

function ShowAppliedDiscounts(order) {
    var wrapper = document.querySelector("#recharge-subscription-portal-v2 .applied-discounts--wrapper");
    var remove = document.querySelector("#recharge-subscription-portal-v2 #discountRemove");
    var discountName = "";
    var discounts = [];

    if (wrapper.hasChildNodes) {
        for (node of wrapper.childNodes) {
            wrapper.removeChild(node);
        }
    }

    for (var i = 0; i < order.orders.length; i++) {
        if (order.orders[i].is_skipped == false) {
            for (var j = 0; j < order.orders[i].charge.discount_codes.length; j++) {
                var discount = order.orders[i].charge.discount_codes[j];
                if (discount.code) {
                    if (!discounts.includes(discount.code)) {
                        discounts.push(discount.code);
                        discountName = discount.code;
                        var span = document.createElement("span");
                        var code = document.createElement("p");
                        code.innerHTML = discountName;
                        span.classList.add("applied-discount-code");
                        var removeButton = remove.cloneNode(true);
                        removeButton.classList.remove('hide');
                        span.appendChild(code);
                        span.appendChild(removeButton);
                        wrapper.appendChild(span);
                    }
                }
            }
        }
    }
}

function HandleSkipNextOrder(e) {
    if (window._rechargeSubscriptionData) {
        var url;
        var subscriptionId;
        var entryIndex = false;

        for (var i = 0; i < window._rechargeSubscriptionData.schedule.length; i++) {
            var entry = window._rechargeSubscriptionData.schedule[i];

            if (entryIndex === false) {
                for (var j = 0; j < window._rechargeSubscriptionData.schedule[i].orders.length; j++) {
                    if (entry.orders[j].is_skipped == false) {
                        var entryIndex = i;
                        break;
                    }
                }
            }

            if (i == entryIndex) {
                HandleLoadingOverlay("show");
                for (order of window._rechargeSubscriptionData.schedule[i].orders) {
                    if (order.subscription.status == "ACTIVE") {
                        subscriptionId = order.subscription.id;
                        url = '/tools/recurring/portal/' + window._rechargeSubscriptionData.customer.hash + '/subscriptions/' + subscriptionId + '/skip?token=' + window.customerToken;
                        $.ajax({
                            url: url, type: "post", dataType: "json"
                        })
                            .done(function (response) {
                                // Successful request made
                                ReCharge.Toast.addToast('Success', 'Next order skipped!');
                                console.log(response);
                                window.location.reload();
                            })
                            .fail(function (response) {
                                // Request failed
                                ReCharge.Toast.addToast('Error', 'Cannot skip next order!');
                                HandleLoadingOverlay("hide");
                                console.log(response);
                            });
                    } else if (order.subscription.status == "ONETIME") {
                        HandleLoadingOverlay("hide");
                        ReCharge.Toast.addToast('Error', 'Cannot skip one-off product orders!');
                    }
                }
            }
        }
    }
}

function HandleRenewNextOrderNow(e) {
    if (window._rechargeSubscriptionData) {
        var url;
        var subscriptionId;
        var entryIndex = false;

        for (var i = 0; i < window._rechargeSubscriptionData.schedule.length; i++) {
            var entry = window._rechargeSubscriptionData.schedule[i];

            if (entryIndex === false) {
                for (var j = 0; j < window._rechargeSubscriptionData.schedule[i].orders.length; j++) {
                    if (entry.orders[j].is_skipped == false) {
                        var entryIndex = i;
                        break;
                    }
                }
            }

            if (i == entryIndex) {
                HandleLoadingOverlay("show");
                for (order of window._rechargeSubscriptionData.schedule[i].orders) {
                    subscriptionId = order.subscription.id;
                    date = new Date().toISOString().split("T")[0];
                    url = '/tools/recurring/portal/' + window._rechargeSubscriptionData.customer.hash + '/subscriptions/' + subscriptionId + '/set_next_charge_date?token=' + window.customerToken;
                    $.ajax({
                        url: url, data: date, type: "post", dataType: "json"
                    })
                        .done(function (response) {
                            // Successful request made
                            ReCharge.Toast.addToast('Success', 'Subscription renewed!');
                            console.log(response);
                            window.location.reload();
                        })
                        .fail(function (response) {
                            // Request failed
                            HandleLoadingOverlay("hide");
                            console.log(response);
                            ReCharge.Toast.addToast('Error', "Couldn't renew next subscription!");
                        });
                }
            }
        }
    }
}

function HandleChangeNextRenewalDate(e) {
    if (window._rechargeSubscriptionData) {
        var url;
        var subscriptionId;
        var entryIndex = false;
        Shopify.queue = [];
        for (var i = 0; i < window._rechargeSubscriptionData.schedule.length; i++) {
            var entry = window._rechargeSubscriptionData.schedule[i];

            if (entryIndex === false) {
                for (var j = 0; j < window._rechargeSubscriptionData.schedule[i].orders.length; j++) {
                    if (entry.orders[j].is_skipped == false) {
                        entryIndex = i;
                        break;
                    }
                }
            }

            if (i == entryIndex) {

                for (order of window._rechargeSubscriptionData.schedule[i].orders) {
                    subscriptionId = order.subscription.id;

                    if (Shopify.queue.includes(subscriptionId) == false) {
                        Shopify.queue.push({
                            subscriptionId: subscriptionId, status: order.subscription.status, shopify_variant_id: order.subscription.shopify_variant_id
                        });
                    }
                    entryIndex = false;
                }
            }
        }

        var current_date = new Date(document.getElementById("renewalDateInput").value).toISOString().split("T")[0];
        console.log("current_date: ", current_date);
        Shopify.moveAlong = function () {

            if (Shopify.queue.length) {

                var subscriptionId = Shopify.queue.shift();
                if (subscriptionId.status == "ACTIVE") {
                    $.ajax({
                        url: url = '/tools/recurring/portal/' + window._rechargeSubscriptionData.customer.hash + '/subscriptions/' + subscriptionId.subscriptionId + '/set_next_charge_date?token=' + window.customerToken,
                        data: {"date": current_date},
                        type: "post",
                        dataType: "json"
                    })
                        .done(function (response) {
                            // Successful request made

                            ReCharge.Toast.addToast('Success', 'Product\'s Subscription renewal date changed!');
                            console.log("Success: ", response);
                            if (Shopify.queue.length) {
                                Shopify.moveAlong()
                            } else {
                                window.location.reload();
                            }

                        })
                        .fail(function (response) {
                            // Request failed
                            if (Shopify.queue.length) {
                                Shopify.moveAlong()
                            }
                            HandleLoadingOverlay("hide");
                            console.log("Failed: ", response);
                            ReCharge.Toast.addToast('Error', "Couldn't update subscription renewal date");
                        });
                } else if (subscriptionId.status == "ONETIME") {
                    url = '/tools/recurring/portal/' + window._rechargeSubscriptionData.customer.hash + '/onetimes/' + subscriptionId.subscriptionId + '?token=' + window.customerToken;
                    $.ajax({
                        url: url, data: {"next_charge_scheduled_at": current_date}, type: "post", dataType: "json"
                    })
                        .done(function (response) {
                            // Successful request made
                            ReCharge.Toast.addToast('Success', 'One-off product renewal date changed!');
                            console.log("Success: ", response);
                            if (Shopify.queue.length) {
                                Shopify.moveAlong()
                            } else {
                                window.location.reload();
                            }
                        })
                        .fail(function (response) {
                            // Request failed
                            HandleLoadingOverlay("hide");
                            console.log("Failed: ", response);
                            ReCharge.Toast.addToast('Error', "Couldn't update one-off product renewal date!");
                        });
                }
            }
        }
        if (e.target.attributes[0].nodeValue == "all_product_select_btn") {
            ShowProductsSelectionPopup();
            var selectedProducts = [];
            $(document).on('click', '.save_btn', function (e) {
                e.preventDefault();
                $('input[name="single_product_checkbox"]:checked').each(function (index, element) {
                    selectedProducts.push({
                        subscriptionId: $(element).val(), status: $(element).data('status'), shopify_variant_id: $(element).data('shopify_variant_id')

                    });
                });
                Shopify.queue = selectedProducts;
                HandleLoadingOverlay("show");
                const keys = ['subscriptionId', 'status', 'shopify_variant_id'];
                // removing duplicate data
                Shopify.queue = Shopify.queue.filter((value, index, self) => self.findIndex(v => keys.every(k => v[k] === value[k])) === index);

                Shopify.moveAlong();

            });
        } else {
            HandleLoadingOverlay("show");
            const keys = ['subscriptionId', 'status', 'shopify_variant_id'];
            // removing duplicate data
            Shopify.queue = Shopify.queue.filter((value, index, self) => self.findIndex(v => keys.every(k => v[k] === value[k])) === index);

            Shopify.moveAlong();
        }
    }
}


function ShowProductsSelectionPopup() {
    var productslist = [];
    if (window._rechargeSubscriptionData) {
        for (var i = 0; i < window._rechargeSubscriptionData.schedule.length; i++) {
            for (order of window._rechargeSubscriptionData.schedule[i].orders) {
                if (order.subscription.status == "ACTIVE" || order.subscription.status == "ONETIME") {
                    productslist.push(order);
                }
            }
        }
        productslist = productslist.filter((value, index, self) => index === self.findIndex((t) => (t.subscription.shopify_variant_id === value.subscription.shopify_variant_id)));
        document.querySelector('.select_product_list_popup').classList.remove('hide');
        var markup = '';
        for (let ii = 0; ii < productslist.length; ii++) {
            const single_product = productslist[ii];
            var skeleton = `
            <div class="single_product">
                <label for="subscription_checkbox-{{subscription_id}}">
                    <img src="{{image}}" />
                    <div class="title_wraper">
                        <input type="checkbox" id="subscription_checkbox-{{subscription_id}}" data-status="` + single_product.subscription.status + `" data-shopify_variant_id="` + single_product.subscription.shopify_variant_id + `" name="single_product_checkbox" value="{{subscription_id}}" >
                        <h3>{{title}}</h3>
                    </div>
                </label>
            </div>
            `;
            var data = {
                'title': single_product.title, 'image': single_product.subscription.product.images[0].large, 'subscription_id': single_product.subscription.id

            }
            markup = markup + TemplateReplace(skeleton, data);

        }
        document.querySelector('.select_product_list_inner').innerHTML = markup;
    }

}

function name(params) {

}

function HandleChangeNextRenewalAddress(e) {
    //This needs a real clean up. Creating a new address and then going through all subs and one times?
    //Easier to just update that address?
    //Do we also want to update all one times and subs or just the next one?
    if (window._rechargeSubscriptionData) {
        var form = SearchParentsFor(e.currentTarget, "addressForm_v2");
        var address1 = form.querySelector("#address_one").value;
        var address2 = form.querySelector("#address_two").value;
        var city = form.querySelector("#city").value;
        var country = form.querySelector("#country").value;
        var firstName = form.querySelector("#first_name").value;
        var lastName = form.querySelector("#last_name").value;
        var phone = form.querySelector("#phone").value;
        var province = form.querySelector("#province").value;
        var postcode = form.querySelector("#zip").value;

        var url;
        var addressId;
        var entryIndex = false;

        var addressData = {
            "address1": address1,
            "address2": address2,
            "cart_note": null,
            "city": city,
            "country": country,
            "first_name": firstName,
            "last_name": lastName,
            "phone": phone,
            "province": province,
            "zip": postcode,
            "payment_method_id": window._rechargeSubscriptions.customer.include.payment_methods[0].id
        }

        HandleLoadingOverlay("show");
        CreateAddress(addressData, function (err, response, xhr) {
            if (err) {
                console.log("Unable to update with err : " + err);
                console.log("Unable to update with xhr : " + xhr);

                HandleLoadingOverlay("hide");
                console.log(response);
                ReCharge.Toast.addToast('Error', "Couldn't change next order shipping address!");
            } else {
                //to do: tighten up to only update active subscriptions
                var addressID = response.address.id;
                var subscriptions = window._rechargeSubscriptions.subscriptions;
                var onetimes = window._rechargeSubscriptions.onetimes;

                function HandleCustomerSubscriptions(subscriptionsIdx) {
                    if (subscriptionsIdx < subscriptions.length) {
                        var subscription = subscriptions[subscriptionsIdx];
                        if (subscription.status == "ACTIVE") {
                            UpdateSubscription(subscription, {"address_id": addressID}, function (err, response, xhr) {
                                if (err) {
                                    console.log("Unable to update with err : " + err);
                                    console.log("Unable to update with xhr : " + xhr);

                                    HandleLoadingOverlay("hide");
                                    console.log(response);
                                    ReCharge.Toast.addToast('Error', "Couldn't change next order shipping address!");
                                } else {
                                    HandleCustomerSubscriptions(subscriptionsIdx + 1);
                                }
                            });
                        } else {
                            HandleCustomerSubscriptions(subscriptionsIdx + 1);
                        }
                    } else {
                        //to do: update one times
                        function HandleCustomerOneTimes(oneTimeIdx) {
                            if (oneTimeIdx < onetimes.length) {
                                var oneTime = onetimes[oneTimeIdx];
                                UpdateOnetimes(oneTime, {"address_id": addressID}, function (err, response, xhr) {
                                    if (err) {
                                        console.log("Unable to update with err : " + err);
                                        console.log("Unable to update with xhr : " + xhr);

                                        HandleLoadingOverlay("hide");
                                        console.log(response);
                                        ReCharge.Toast.addToast('Error', "Couldn't change next order shipping address!");
                                    } else {
                                        HandleCustomerOneTimes(oneTimeIdx + 1);
                                    }
                                });
                            } else {
                                //Finish
                                window.location.reload();
                            }
                        }

                        if (onetimes && onetimes.length) {
                            HandleCustomerOneTimes(0);
                        } else {
                            //Finish
                            window.location.reload();
                        }
                    }
                }

                HandleCustomerSubscriptions(0);
            }
        });

        // for( var i = 0; i < window._rechargeSubscriptionData.schedule.length; i++ )
        // {
        //     var entry = window._rechargeSubscriptionData.schedule[ i ];

        //     if( entryIndex === false )
        //     {
        //         for( var j = 0; j < window._rechargeSubscriptionData.schedule[ i ].orders.length; j++ )
        //         {
        //             if( entry.orders[ j ].is_skipped == false )
        //             {
        //                 var entryIndex = i;
        //                 break;
        //             }
        //         }
        //     }

        //     if( i == entryIndex )
        //     {
        //         HandleLoadingOverlay( "show" );
        //         for( order of window._rechargeSubscriptionData.schedule[ i ].orders )
        //         {
        //             addressId = order.subscription.address_id;
        //             url = '/tools/recurring/portal/' + window._rechargeSubscriptionData.customer.hash + '/addresses/' + addressId + '?token=' + window.customerToken;
        //             $.ajax(
        //             {
        //                 url: url,
        //                 data: {
        //                         "address1": address1,
        //                         "address2": address2,
        //                         "cart_note": null,
        //                         "city": city,
        //                         "company": company,
        //                         "country": country,
        //                         "first_name": firstName,
        //                         "last_name": lastName,
        //                         "phone": phone,
        //                         "province": province,
        //                         "zip": postcode
        //                       },
        //                 type: "post",
        //                 dataType: "json"
        //             } )
        //             .done(function (response)
        //             {
        //                 // Successful request made
        //                 ReCharge.Toast.addToast('Success', 'Next order shipping address changed!');
        //                 console.log(response);
        //                 window.location.reload();
        //             } )
        //             .fail(function (response)
        //             {
        //                 // Request failed
        //                 HandleLoadingOverlay( "hide" );
        //                 console.log(response);
        //                 ReCharge.Toast.addToast('Error', "Couldn't change next order shipping address!");
        //             } );
        //         }
        //     }
        // }
    }
}

function CreateAddress(data, cb) {
    var url = ReCharge.Endpoints.list_addresses_url();
    console.log()
    SendRCAPIRequest(url, "POST", "Schema in url", data, function (err, response, xhr) {
        cb(err, response, xhr);
    });
}

function UpdateSubscription(subscription, update, cb) {
    SendRCAPIRequest("subscriptions/" + subscription.id, "POST", null, update, function (err, response, xhr) {
        cb(err, response, xhr);
    });
}

function UpdateOnetimes(onetime, update, cb) {
    SendRCAPIRequest("onetimes/" + onetime.id, "POST", null, update, function (err, response, xhr) {
        cb(err, response, xhr);
    });
}

function ToggleDiscountAccordion() {
    var discountWrapper = document.querySelector('#recharge-subscription-portal-v2 .active_subscription_discount_wrapper');
    var wrapperChevron = document.querySelector('#recharge-subscription-portal-v2 .active-subscription__discount--row .discount-header svg');

    if (discountWrapper.style.height == "0px" || discountWrapper.style.height == 0) {
        discountWrapper.style.height = "auto";
        wrapperChevron.classList.remove('fa-chevron-down');
        wrapperChevron.classList.add('fa-chevron-up');
    } else {
        discountWrapper.style.height = "0px";
        wrapperChevron.classList.remove('fa-chevron-up');
        wrapperChevron.classList.add('fa-chevron-down');
    }
}

function ShowRenewalDatePicker() {
    var input = document.getElementById("renewalDateInput");
    var now = new Date();
    var msBetweenDates = Math.abs(new Date(input.value).getTime() - now.getTime());
    var hoursBetweenDates = msBetweenDates / (60 * 60 * 1000);

    if (hoursBetweenDates > 24) {
        input.classList.remove("hide");
        input.min = new Date().toISOString().split("T")[0];
        document.querySelector("#recharge-subscription-portal-v2 #editRenewalDateBtn span").classList.add("hide");
        document.querySelector("#recharge-subscription-portal-v2 #editRenewalDateBtn svg").classList.remove("hide");
        document.querySelector(".manage__subscription_dates").classList.remove("hide");
    } else {
        ReCharge.Toast.addToast("You're unable to edit this order", 'The renewal date is within 24 hours!');
    }
}

function ToggleEditAddressForm() {
    var form = document.getElementById("addressForm");
    if (form.classList.contains("move-right")) {
        form.classList.remove("move-right");
        document.querySelector("#recharge-subscription-portal-v2 #editAddressBtn span").classList.add("move-right");
    } else {
        form.classList.add("move-right");
        document.querySelector("#recharge-subscription-portal-v2 #editAddressBtn span").classList.remove("move-right");
    }
}

function HandlePaymentFormURL() {
    if (window._rechargeSubscriptionData) {
        var url = '/tools/recurring/portal/' + window._rechargeSubscriptionData.customer.hash + '/payment_methods?token=' + window.customerToken;
        window.location.href = url;
    }
}

function ApplyNextOrderDiscount(removeDiscount = true) {
    if (window._rechargeSubscriptionData) {
        var url;
        var addressId;
        var entryIndex = false;
        var discountInput = document.querySelector('#recharge-subscription-portal-v2 #discountString');
        var discountVal = discountInput.value;
        var address_Ids = [];

        for (var i = 0; i < window._rechargeSubscriptionData.schedule.length; i++) {
            var entry = window._rechargeSubscriptionData.schedule[i];

            if (entryIndex === false) {
                for (var j = 0; j < window._rechargeSubscriptionData.schedule[i].orders.length; j++) {
                    if (entry.orders[j].is_skipped == false) {
                        var entryIndex = i;
                        break;
                    }
                }
            }

            if (i == entryIndex) {
                HandleLoadingOverlay("show");
                for (order of window._rechargeSubscriptionData.schedule[i].orders) {
                    addressId = order.subscription.address_id;
                    if (!address_Ids.includes(addressId)) {
                        address_Ids.push(addressId);
                        url = '/tools/recurring/portal/' + window._rechargeSubscriptionData.customer.hash + '/addresses/' + addressId + '/apply_discount?token=' + window.customerToken;
                        $.ajax({
                            url: url, data: {"discount_code": discountVal}, type: "post", dataType: "json"
                        })
                            .done(function (response) {
                                // Successful request made
                                ReCharge.Toast.addToast('Success', 'Discount applied!');
                                console.log(response);
                                window.location.reload();
                            })
                            .fail(function (response) {
                                // Request failed
                                console.log(response);
                                if(removeDiscount) {
                                    removeAllDiscounts();
                                }else {
                                    HandleLoadingOverlay("hide");
                                    ReCharge.Toast.addToast('Error', "Discount code is invalid/expired");
                                }
                            });
                    }
                }
            }
        }
    }
}

function removeAllDiscounts(addressIndex = 0){
    if(window._rechargeSubscriptionData.addresses.length > addressIndex){
        url = '/tools/recurring/portal/' + window._rechargeSubscriptionData.customer.hash + '/addresses/' + window._rechargeSubscriptionData.addresses[addressIndex].id + '/remove_discount?token=' + window.customerToken;
        $.ajax({
            url: url, type: "post", dataType: "json"
        })
            .done(function (response) {
                removeAllDiscounts(addressIndex+1);
            })
            .fail(function (response) {
                removeAllDiscounts(addressIndex+1);
            });
    }else{
        ApplyNextOrderDiscount(false);
    }
}

function RemoveNextOrderDiscount(e) {
    if (window._rechargeSubscriptionData) {
        var url;
        var addressId;
        var entryIndex = false;
        var parent = SearchParentsFor(e.currentTarget, "applied-discount-code");
        var discountVal = parent.querySelector("p").innerHTML;
        var address_Ids = [];

        for (var i = 0; i < window._rechargeSubscriptionData.schedule.length; i++) {
            var entry = window._rechargeSubscriptionData.schedule[i];

            if (entryIndex === false) {
                for (var j = 0; j < window._rechargeSubscriptionData.schedule[i].orders.length; j++) {
                    if (entry.orders[j].is_skipped == false) {
                        var entryIndex = i;
                        break;
                    }
                }
            }

            if (i == entryIndex) {
                HandleLoadingOverlay("show");
                for (order of window._rechargeSubscriptionData.schedule[i].orders) {
                    addressId = order.subscription.address_id;
                    if (!address_Ids.includes(addressId)) {
                        address_Ids.push(addressId);
                        // date = new Date( today( ) );
                        url = '/tools/recurring/portal/' + window._rechargeSubscriptionData.customer.hash + '/addresses/' + addressId + '/remove_discount?token=' + window.customerToken;
                        $.ajax({
                            url: url, data: {"discount_code": discountVal}, type: "post", dataType: "json"
                        })
                            .done(function (response) {
                                // Successful request made
                                ReCharge.Toast.addToast('Success', 'Discount removed!');
                                console.log(response);
                                window.location.reload();
                            })
                            .fail(function (response) {
                                // Request failed
                                HandleLoadingOverlay("hide");
                                console.log(response);
                                ReCharge.Toast.addToast('Error', 'Failed to remove discount!');
                            });
                    }
                }
            }
        }
    }
}

function CancelProductSubscription(e) {
    var cancellation_reason_dropdown = SearchParentsFor(e.currentTarget, "subscription-action__wrapper").querySelector("#product_remove_reason_dropdown").value
    var cancellation_reason_text = SearchParentsFor(e.currentTarget, "subscription-action__wrapper").querySelector("#product_remove_reason").value
    var error_message_reason = SearchParentsFor(e.currentTarget, "subscription-action__wrapper").querySelector(".error_message")
    var cancellation_reason = 'Reason: ' + cancellation_reason_dropdown +",   "+cancellation_reason_text
    if(cancellation_reason_dropdown) {
        error_message_reason.classList.add('hide');
        console.log(cancellation_reason);
        HandleLoadingOverlay("show");
        subscriptionId = e.currentTarget.dataset.id;
        console.log('e.currentTarget', e.currentTarget);
        console.log('subscriptionID' + subscriptionId);
        url = '/tools/recurring/portal/' + window._rechargeSubscriptionData.customer.hash + '/subscriptions/' + subscriptionId + '/cancel?token=' + window.customerToken;
        $.ajax({
            url: url, data: {
                'cancellation_reason': cancellation_reason
            }, type: "post", dataType: "json"
        })
            .done(function (response) {
                // Successful request made
                ReCharge.Toast.addToast('Success', 'Subscription cancelled!');
                console.log("Success: ", response);
                window.location.reload();
            })
            .fail(function (response) {
                // Request failed
                HandleLoadingOverlay("hide");
                console.log("Failed: ", response);
                ReCharge.Toast.addToast('Error', 'Failed to cancel subscription!');
            });
    } else {
        error_message_reason.classList.remove('hide');
    }
}

function CancelProductOnetime(e) {
    HandleLoadingOverlay("show");
    onetimeId = e.currentTarget.dataset.id;
    url = '/tools/recurring/portal/' + window._rechargeSubscriptionData.customer.hash + '/onetimes/' + onetimeId + '/cancel?token=' + window.customerToken;
    $.ajax({
        url: url, data: {cancellation_reason: "Other reason"}, type: "post", dataType: "json"
    })
        .done(function (response) {
            // Successful request made
            ReCharge.Toast.addToast('Success', 'One-off product cancelled!');
            console.log(response);
            window.location.reload();
        })
        .fail(function (response) {
            // Request failed
            HandleLoadingOverlay("hide");
            console.log(response);
            ReCharge.Toast.addToast('Error', 'Failed to cancel one-off product!');
        });
}

function SkipProductSubscription(e) {
    HandleLoadingOverlay("show");
    subscriptionId = e.currentTarget.dataset.id;
    url = '/tools/recurring/portal/' + window._rechargeSubscriptionData.customer.hash + '/subscriptions/' + subscriptionId + '/skip?token=' + window.customerToken;
    $.ajax({
        url: url, type: "post", dataType: "json"
    })
        .done(function (response) {
            // Successful request made
            ReCharge.Toast.addToast('Success', 'Next product subscription is skipped!');
            console.log(response);
            window.location.reload();
        })
        .fail(function (response) {
            // Request failed
            HandleLoadingOverlay("hide");
            console.log(response);
            ReCharge.Toast.addToast('Error', 'Failed to skip product subscription!');
        });
}

function UnskipProductSubscription(e) {
    HandleLoadingOverlay("show");
    subscriptionId = e.currentTarget.dataset.id;
    url = '/tools/recurring/portal/' + window._rechargeSubscriptionData.customer.hash + '/subscriptions/' + subscriptionId + '/unskip?token=' + window.customerToken;
    $.ajax({
        url: url, type: "post", dataType: "json"
    })
        .done(function (response) {
            // Successful request made
            ReCharge.Toast.addToast('Success', 'Product subscription continued!');
            console.log(response);
            window.location.reload();
        })
        .fail(function (response) {
            // Request failed
            HandleLoadingOverlay("hide");
            console.log(response);
            ReCharge.Toast.addToast('Error', 'Failed to continue product subscription!');
        });
}

function HandleChangeSubscriptionDetails(e) {
    // HandleLoadingOverlay( "show" );
    var parent = SearchParentsFor(e.currentTarget, "rc_subscription_info");
    var quantity = parseInt(parent.querySelector(".quantity__input").value);
    var mainparent = SearchParentsFor(e.currentTarget, "rc_active_subscription_container");
    var subscriptionStatus = $(mainparent).find('.subscription_badge').data('budgetype');
    subscriptionId = e.currentTarget.dataset.subId;
    if (subscriptionStatus == "Subscription") {

        var urlType = 'addresses';
        if ($(mainparent).find('.frequency__wrapper').length > 0) {
            urlType = 'subscriptions';
        }
        select = parent.querySelector(".freqDropdown");
        frequency = select.options[select.selectedIndex].value;
        url = '/tools/recurring/portal/' + window._rechargeSubscriptionData.customer.hash + '/' + urlType + '/' + subscriptionId + '?token=' + window.customerToken;
        $.ajax({
            url: url, data: {
                "quantity": quantity, "charge_interval_frequency": frequency, "order_interval_frequency": frequency, "order_interval_unit": "week",
            }, type: "post", dataType: "json"
        })
            .done(function (response) {
                // Successful request made
                ReCharge.Toast.addToast('Success', 'Product subscription updated!');
                console.log(response);
                window.location.reload();
            })
            .fail(function (response) {
                // Request failed
                HandleLoadingOverlay("hide");
                console.log(response);
                ReCharge.Toast.addToast('Error', 'Failed to update product subscription!');
            });
    } else if (subscriptionStatus == "One-off") {

        url = '/tools/recurring/portal/' + window._rechargeSubscriptionData.customer.hash + '/subscriptions/' + subscriptionId + '?token=' + window.customerToken;
        $.ajax({
            url: url, data: {
                "quantity": quantity,
            }, type: "post", dataType: "json"
        })
            .done(function (response) {
                // Successful request made
                ReCharge.Toast.addToast('Success', 'One-off Product subscription updated!');
                console.log(response);
                window.location.reload();
            })
            .fail(function (response) {
                // Request failed
                HandleLoadingOverlay("hide");
                console.log(response);
                ReCharge.Toast.addToast('Error', "Couldn't update one-off product renewal date!");
            });

    }
}

function SendRCAPIRequest(endpoint, method, qpout, payload, cb) {
    if (qpout != "Schema in url") {
        var url = RC_BaseURL() + "/" + endpoint;
        var qp = ParseQP();

        url += "?token=" + qp.token;
        if (qpout) {
            url += qpout;
        }
    } else {
        url = endpoint;
    }

    SendAPIRequest(url, method, payload, cb);
}


function RefreshSubscriptionView() {
    window.onload = function() {
        var schemaStr = "&schema=%7B%20%22schedule%22%3A%20%5B%5D%2C%20%22addresses%22%3A%20%5B%5D%2C%22subscriptions%22%3A%7B%22product%22%3A%5B%5D%7D%2C%20%20%22charges%22%3A%20%7B%22status%22%3A%20%22error%22%7D%2C%20%22customer%22%3A%20%7B%7D%2C%20%22settings%22%3A%20%7B%7D%2C%20%22store%22%3A%20%7B%7D%2C%22orders%22%3A%20%7B%20%22status%22%3A%20%22SUCCESS%22%2C%20%22sort_by%22%3A%20%22shipped_date-desc%22%20%7D%20%7D";
        SendRCAPIRequest("request_objects", "GET", schemaStr, null, function (err, response, xhr) {
            console.log("got ", response);
            if(response.charges.length > 0){
                for(var errors=0;errors<response.charges.length;errors++){
                    $(".active-subscription__discount--row").append("<p class='error-subscription'>There was an issue with your latest renewal. Issue ID: "+response.charges[errors].error_type+"</p>");
                }
            }
            var cancelreasonsHTMl = document.querySelector("[data-cancelreasons]");

            if (response) {
                // yuck : nasty global as a convenient shortcut
                window._rechargeSubscriptionData = response;

                var target = document.querySelector("#recharge-subscription-portal-v2 .rc_subscription_container");
                var subs = {};
                var entryIndex = false;

                // remove all current order products
                if (target && target.hasChildNodes && target.childNodes.length > 0) {
                    console.log(target.childNodes);
                    for (node of target.childNodes) {
                        target.removeChild(node);
                    }
                }

                GetCustomerSubscriptions();
                if(response.schedule.length) {
                    for (var i = 0; i < response.schedule.length; i++) {
                        var entry = response.schedule[i];

                        if (entryIndex === false) {
                            for (var j = 0; j < entry.orders.length; j++) {
                                if (entry.orders[j].is_skipped == false) {
                                    entryIndex = i;
                                    break;
                                }
                            }
                        }

                        if (i == entryIndex) {
                            ShowNextOrderDetails(response, entry);
                        }

                        // look at all "orders" in this "schedule entry"
                        for (var j = 0; j < entry.orders.length; j++) {
                            var order = entry.orders[j];
                            if (order.subscription.status == "ACTIVE") {
                                // this is an active subscription, show it in the list unless it's already showing
                                var sid = order.subscription.id;

                                if (subs[sid] == undefined) {
                                    subs[sid] = entry;
                                    target.appendChild(CreateSubscriptionRow(entry, order, cancelreasonsHTMl));
                                    SetProductPrices(entry);
                                }
                            } else if (order.subscription.status == "ONETIME") {
                                // this is a onetime order, show it in the list unless it's already showing
                                var sid = order.subscription.id;

                                if (subs[sid] == undefined) {
                                    subs[sid] = entry;
                                    target.appendChild(CreateSubscriptionRow(entry, order, cancelreasonsHTMl));
                                    SetProductPrices(entry);
                                    // CreateSubscriptionRowForUpcomingOrderDetails( entry, order);
                                }
                            }
                        }
                    }
                }else{
                    var subscriptions = response.subscriptions;
                    for (var i = 0; i < subscriptions.length; i++){
                        var subscription = subscriptions[i];
                        if(subscription.status == 'ACTIVE'){
                            var entry = {
                                date:'',
                                when:'',
                            }

                            var order= {
                                title:subscription.product_title,
                                is_skipped:'',
                                subscription:subscription,
                                charge:{
                                    status:'',
                                    address_id:subscription.address_id
                                }
                            }

                            var reason = {
                                innerHTML:'',
                            }
                            target.appendChild(CreateSubscriptionRow(entry, order, cancelreasonsHTMl));
                            SetProductPrices(entry);
                        }
                    }
                }
                HandleOnetimeMarkup();

                AddSubscriptionEventListeners();
            }
        });
    }
}

function getParameterByNameScrumble(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function GetCustomerSubscriptions() {
    if (window._rechargeSubscriptionData) {
        var schemaStr = '{ "addresses": { "discount": { "id": "parent.discount_id" } }, "subscriptions": { "product": {} }, "onetimes": { "product": {} }, "customer": {}, "settings": {}, "store": {} }';
        var customerToken = window.customerToken;
        if(!customerToken || typeof(customerToken) === 'undefined'){
            customerToken = getParameterByNameScrumble('token');
        }
        url = window.location.origin+'/tools/recurring/portal/' + window._rechargeSubscriptionData.customer.hash + '/request_objects?token=' + customerToken + '&schema=' + schemaStr;
        console.log("URL is: "+url);
        $.ajax({
            url: url, type: "get", dataType: "json"
        })
            .done(function (response) {
                window._rechargeSubscriptions = response;
            });
    }
}


async function addProductHandlerV2(evt, RCUrl, paginationType) {
    var sidebar = `<div class="">
    <div id="search-container" class="rc_card_container border-light">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18.052" height="18.052" viewBox="0 0 18.052 18.052" class="margin-right-10"><g id="Group_5" data-name="Group 5"><path id="Path_26" data-name="Path 26" d="M11.493,4.814A2.441,2.441,0,0,1,13.25,6.559a.8.8,0,0,0,1.593-.14A3.6,3.6,0,0,0,13.7,4.3a3.312,3.312,0,0,0-2.062-1.1.815.815,0,0,0-.8.814.8.8,0,0,0,.662.79M.466,15.331a1.593,1.593,0,0,0,2.25,2.254l4.609-4.605a7.023,7.023,0,1,0-2.254-2.254ZM6.018,7.02a5.014,5.014,0,1,1,5.014,5.014A5.016,5.016,0,0,1,6.018,7.02" transform="translate(0)" fill="#025156" fill-rule="evenodd"></path></g></svg>
      <input type="search" name="search" value="" placeholder="Search for a product to add" id="rc_search">
    </div>
  
    <ul class="rc_product_list_container"> 
    </ul>
    
        <style>
            body#recharge-novum #recharge-te .rct_pagination__container {
                display: flex;
                justify-content: center;
                align-items: center;
            }
            
            body#recharge-novum #recharge-te .rct_pagination__prev,
            body#recharge-novum #recharge-te .rct_pagination__next {
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid var(--primary-color) !important;
                padding: 10px;
                height: 40px;
                width: 40px !important;
                border-radius: 50% !important;
                margin-bottom: 0 !important;
                font-size: 18px;
                color: var(--primary-color);
            }
            
            body#recharge-novum #recharge-te .rct_pagination__prev:hover,
            body#recharge-novum #recharge-te .rct_pagination__next:hover {
                cursor: pointer;
            }
            
            body#recharge-novum #recharge-te .rct_pagination__page {
                margin: 0 6px;
                padding: 8px;
            }
            
            body#recharge-novum #recharge-te .rct_pagination__page--current {
                font-weight: 700;
                color: var(--primary-color);
                margin: 0px 10px;
            }
            
            body#recharge-novum #recharge-te .rct_pagination__container--hidden {
                display: none;
            }
            
            body#recharge-novum #recharge-te .rct_pagination__prev--disabled,
            body#recharge-novum #recharge-te .rct_pagination__next--disabled {
                opacity: 0.5;
                pointer-events: none;
            }
        </style>
        <div class="rct_pagination__container rct_pagination__container--add rct_pagination__container--hidden">
            <button 
                aria-label="previous page"
                class="rct_pagination__prev rct_pagination__prev--add rct_pagination__prev--disabled"
                onclick="ReCharge.Novum.Pagination.previousPageHandler(event)"
                data-handler-type="add"
            >
                <i class="fas fa-chevron-left"></i>
            </button>
            <span 
                class="rct_pagination__page rct_pagination__current--add rct_pagination__page--current" 
                data-pagination-current-page
                data-handler-type="add"
            >
                1
            </span>
            <button
                aria-label="next page"
                class="rct_pagination__next rct_pagination__next--add "
                onclick="ReCharge.Novum.Pagination.nextPageHandler(event); scrollModal();"
                data-handler-type="add"
            >
                <i class="fas fa-chevron-right"></i>
            </button>
        </div>
  </div>`

    evt.preventDefault();

    // Hide back button
    ReCharge.Novum.backBtn.setAttribute('style', 'visibility: hidden');
    ReCharge.Novum.backBtn.setAttribute('aria-hidden', 'true');

    ReCharge.Novum.sidebarHeading.innerHTML = "Select Product";
    ReCharge.Novum.sidebarContent.innerHTML = sidebar;

    var schemaStr = "Schema in url";
    var url;
    if (!RCUrl) {
        schema = {"products": {"page": 1, "base_source": "store_settings", "limit": 6, "action_type": "add_product", "product_types": "subscription,onetime"}}
        schemaStr = "&schema=" + encodeURIComponent(JSON.stringify(schema));
    }

    if (!RCUrl) {
        url = "request_objects";
    } else {
        url = RCUrl;
    }

    SendRCAPIRequest(url, "GET", schemaStr, null, function (err, response, xhr) {
        if (xhr && xhr.status == 200) {
            //to do: tidy this all up so that search, pagination and first rendering are all separate
            var productsToRender = response.products;
            //Copied from _scripts.js getProducts function. Looks like it does something before returning the product data
            ReCharge.Novum.Pagination.limit = schema.products.limit;
            ReCharge.Novum.products = response.products;

            if (response.meta && response.meta.products) {
                ReCharge.Novum.meta = response.meta.products;
                if (schema.products.limit === 12) {
                    ReCharge.Novum.upsellMeta = response.meta.products;
                    ReCharge.Novum.Pagination.limit = 12;
                } else if (schema.products.limit === 6) {
                    ReCharge.Novum.addMeta = response.meta.products;
                    ReCharge.Novum.Pagination.limit = 6;
                }
            }

            delete window.locked;

            if (!paginationType) {
                ReCharge.Novum.Pagination.currentAddPage = 1;
            }
            ReCharge.Novum.Pagination.limit = 6;
            ReCharge.Novum.Pagination.type = 'add';
            RenderProductAddSidebar(productsToRender, "add");
            ReCharge.Novum.Pagination.renderInitialPagination();

            let input = document.getElementById('rc_search');
            input.addEventListener('keyup', ProductsAddSearch);

            if (!RCUrl) {
                !evt.target.closest('.js-back-btn') && ReCharge.Novum.toggleSidebar(evt.currentTarget);
            }

            HandleSideBarPagination(evt, response, paginationType);
        } else {
            console.log("Unable to get recharge products with error : " + JSON.stringify(err));
            console.log("Unable to get recharge products xhr : " + JSON.stringify(err));
        }
    });
}

function RenderProductAddSidebar(products, type) {
    const productsContainer = document.querySelector('.rc_product_list_container');
    productsContainer.innerHTML = '';

    if (!products.length) {
        return productsContainer.innerHTML = "No products found";
    }

    var productCardTemplateAdd = '<li class="rc_product_card border-light text-center rc_single_product_card-wrapper">' + '<div class="rc_image_container">' + '<img class="rc_img__sidebar" height="100px" width="100px">' + '</div>' + '<p class="product__title"></p>' + '<select class="product__variant--dropdown-select"></select>' + '<div class="rc-container-wrapper">' + '<div class="options-wrapper">' + '<div class="option option__subSave option--active" data-sub-id="subSave_option_1">' + '<input id="subSave_1" type="radio" name="selling_plan_1" value="subscriptions" checked />' + '<label for="subSave_1">Subscribe <span>10% off</span></label>' + '</div>' + '<div class="option option__onetime" role="radio" data-sub-id="onetime_option_1" aria-expanded="false">' + '<input id="onetime_1" role="radio" type="radio" value="onetimes" name="selling_plan_1" />' + '<label for="onetime_1">One-time</label>' + '</div>' + '</div>' + '<div class="option-content--wrapper">' + '<div id="subSave_option_1" class="option option--active">' + '<select class="selling_plan_groups"></select>' + '</div>' + '<div id="onetime_option_1" class="option">' + '<div class="onetime_option--content">' + '<div class="icon-wrapper">' + '<svg class="icon icon-subscription" viewBox="0 0 122.88 109.93" style="enable-background:new 0 0 122.88 109.93" xml:space="preserve">' + '<path d="M115.47,65.19c-2.39,12.7-9.16,23.86-18.67,31.85c-9.57,8.04-21.89,12.88-35.33,12.88c-12.63,0-24.28-4.27-33.57-11.45 C18.4,91.14,11.38,80.77,8.27,68.81l6.86-1.78c2.7,10.41,8.82,19.44,17.09,25.83c8.08,6.24,18.22,9.95,29.24,9.95 c11.73,0,22.47-4.21,30.78-11.19c7.95-6.68,13.7-15.91,15.98-26.44h-7.33l10.99-13.39l10.99,13.39H115.47L115.47,65.19z M61.29,69.07V56.52c-4.42-1.12-7.65-2.81-9.7-5.07c-2.06-2.27-3.1-5.02-3.1-8.26c0-3.28,1.17-6.04,3.5-8.26 c2.33-2.23,5.43-3.51,9.3-3.85v-2.95h4.94v2.95c3.62,0.38,6.49,1.47,8.64,3.26c2.13,1.79,3.5,4.19,4.09,7.19l-8.63,0.98 c-0.53-2.36-1.9-3.96-4.1-4.8v11.71c5.46,1.29,9.18,2.98,11.15,5.04c1.98,2.07,2.97,4.72,2.97,7.96c0,3.62-1.24,6.66-3.73,9.14 c-2.49,2.48-5.95,4.02-10.39,4.63v5.6h-4.94v-5.53c-3.9-0.42-7.06-1.69-9.51-3.83c-2.45-2.14-4-5.17-4.68-9.08l8.83-0.92 c0.36,1.6,1.04,2.97,2.04,4.13C58.97,67.72,60.07,68.55,61.29,69.07L61.29,69.07z M61.29,37.6c-1.33,0.42-2.38,1.11-3.15,2.07 c-0.78,0.96-1.16,2.02-1.16,3.18c0,1.06,0.35,2.04,1.06,2.95c0.71,0.9,1.8,1.64,3.26,2.19V37.6L61.29,37.6z M66.23,69.57 c1.7-0.33,3.1-1.05,4.16-2.15C71.47,66.31,72,65.01,72,63.5c0-1.33-0.45-2.49-1.36-3.45c-0.89-0.97-2.36-1.71-4.42-2.23V69.57 L66.23,69.57z M7.46,44.74C9.83,32.15,16.5,21.08,25.87,13.1C35.47,4.93,47.9,0,61.46,0c11.93,0,22.97,3.8,31.98,10.26 c9.25,6.63,16.35,16.06,20.08,27.06l-3.36,1.14l-3.36,1.14c-0.09-0.28-0.19-0.56-0.29-0.83c-3.31-9.21-9.38-17.11-17.2-22.72 c-7.84-5.62-17.45-8.93-27.84-8.93c-11.84,0-22.67,4.28-31.01,11.38c-7.84,6.67-13.49,15.82-15.76,26.24h7.29L10.99,58.13L0,44.74 H7.46L7.46,44.74z"></path>' + '</svg>' + '</div>' + '<div class="text-content">' + '<p class="message">You could save with a subscription <span>Why not switch to our subscription service for 15% off forever</span></p>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>' + '<div class="product__button-wrapper">' + '<div class="product__quantity--wrapper">' + '<button class="quantity--minus">' + '<svg xmlns="http://www.w3.org/2000/svg" width="13.538" height="2" viewBox="0 0 13.538 2">' + '<g id="Group_2909" data-name="Group 2909" transform="translate(1 1)">' + '<line id="Line_31" data-name="Line 31" x1="11.538" transform="translate(0)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></line>' + '</g>' + '</svg>' + '</button>' + '<input type="text" id="Quantity-" class="js-qty__num" value="1" min="1" aria-label="quantity" pattern="[0-9]*" name="quantity">' + '<button class="quantity--plus plus-center">' + '<svg xmlns="http://www.w3.org/2000/svg" width="13.538" height="13.538" viewBox="0 0 13.538 13.538">' + '<g id="Group_2909" data-name="Group 2909" transform="translate(1 1)">' + '<line id="Line_30" data-name="Line 30" y2="11.538" transform="translate(5.769 0)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></line>' + '<line id="Line_31" data-name="Line 31" x1="11.538" transform="translate(0 5.769)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></line>' + '</g>' + '</svg>' + '</button>' + '</div>' + '<button class="btn-section subscription-btn js-quick-add-btn" id="sub__btn--" data-checked="false" data-var-id="">Add</button>' + '</div>' + '</li>';

    products.forEach(function (product, i) {
        if (!AlreadySubscribedToProduct(product)) {
            var copy = ConvertStringToHTML(productCardTemplateAdd);
            var container = copy.querySelector(".rc_product_card");
            var image = copy.querySelector(".rc_img__sidebar");
            var title = copy.querySelector(".product__title");
            var variantSelect = copy.querySelector(".product__variant--dropdown-select");
            var rcContainer = copy.querySelector(".rc-container-wrapper");

            container.setAttribute("id", product.shopify_product_id);
            container.setAttribute("data-idx", i);
            image.setAttribute("src", ReCharge.Novum.Utils.getImageUrl(product));
            image.setAttribute("alt", product.title);
            title.innerText = product.title;

            product.shopify_details.variants.forEach(function (variant) {
                var option = document.createElement("option");
                option.setAttribute("value", variant.shopify_id);
                option.setAttribute("data-price", variant.price);
                option.setAttribute("data-product-title", product.title);
                // var variant_discount_amount = ((variant.price * recharge_portal_data.recharge_percentage_off) / 100 );
                // var variant_discounted_price = (variant.price - variant_discount_amount );
                // console.log('variant_discounted_price::: ', variant_discounted_price);
                var variantPrice = variant.price * 0.85;
                // console.log('variantPrice::: ', variantPrice);
                option.innerText = variant.title + " - " + ReCharge.Novum.Utils.getCurrency() + priceRound(variantPrice, 2).toFixed(2);

                variantSelect.appendChild(option);
            });   

            UpdateSubscriptionIDS(copy, i)
            ShowSubscriptionSettingsForProduct(copy, rcContainer, product);

            AddProductCardEventListeners(copy);

            productsContainer.appendChild(copy);
        }
    });
}

function priceRound(value, exp) {
    if (typeof exp === 'undefined' || +exp === 0)
        return Math.round(value);

    value = +value;
    exp = +exp;

    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0))
        return NaN;

    // Shift
    value = value.toString().split('e');
    value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)));

    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp));
}


function UpdateSubscriptionIDS(copy, idx) {
    var subscriptionOptions = copy.querySelectorAll(".rc-container-wrapper .options-wrapper .option");
    var contentWrapperChildren = copy.querySelector(".rc-container-wrapper .option-content--wrapper").childNodes;

    for (var i = 0; i < subscriptionOptions.length; i++) {
        var subscriptionOption = subscriptionOptions[i];
        var children = subscriptionOption.childNodes;
        var subscriptionOptionAttributes = subscriptionOption.attributes;

        subscriptionOptionAttributes.forEach(function (subscriptionOptionAttribute) {
            if (subscriptionOptionAttribute.value.includes("_1")) {
                subscriptionOptionAttribute.value = subscriptionOptionAttribute.value.replace("_1", "_" + idx);
            }
        });

        children.forEach(function (child) {
            var childAttributes = child.attributes;
            if (childAttributes && childAttributes.length) {
                childAttributes.forEach(function (childAttribute) {
                    if (childAttribute.value.includes("_1")) {
                        childAttribute.value = childAttribute.value.replace("_1", "_" + idx);
                    }
                });
            }
        });
    }


    contentWrapperChildren.forEach(function (contentWrapperChild) {
        var contentWrapperChildrenAttributes = contentWrapperChild.attributes;
        contentWrapperChildrenAttributes.forEach(function (contentWrapperChildrenAttribute) {
            if (contentWrapperChildrenAttribute.value.includes("_1")) {
                contentWrapperChildrenAttribute.value = contentWrapperChildrenAttribute.value.replace("_1", "_" + idx);
            }
        });
    });
}

function AlreadySubscribedToProduct(product) {
    var subscriptions = ReCharge.Novum.subscriptions;

    subscriptions.forEach(function (subscription) {
        if (subscription.status == "ACTIVE") {
            if (subscription.product.id == product.id) {
                return true;
            }
        }
    });
}

function ConvertStringToHTML(str) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(str, 'text/html');
    return doc.body;
};

function ShowSubscriptionSettingsForProduct(copy, rcContainer, product) {
    var sellingPlanSelect = copy.querySelector(".selling_plan_groups");

    var subscriptionDefaults = product.subscription_defaults;
    for (var i = 0; i < subscriptionDefaults.order_interval_frequency_options.length; i++) {
        var orderIntervalFrequencyOption = subscriptionDefaults.order_interval_frequency_options[i];
        var orderIntervalUnit = subscriptionDefaults.order_interval_unit;

        var option = document.createElement("option");
        option.setAttribute("data-order-interval-frequency", orderIntervalFrequencyOption);
        option.setAttribute("data-order-interval-unit", orderIntervalUnit);
        option.innerText = "Every " + orderIntervalFrequencyOption + " " + orderIntervalUnit;

        if (Number(orderIntervalFrequencyOption) > 1) {
            option.innerText = option.innerText + "(s)";
        }

        sellingPlanSelect.appendChild(option);
    }
}

function AddProductCardEventListeners(copy) {
    var qtyButtons = copy.querySelectorAll(".product__quantity--wrapper button");
    var subscriptionOptions = copy.querySelectorAll(".options-wrapper .option");
    var btn = copy.querySelector(".subscription-btn");

    qtyButtons.forEach(function (btn) {
        btn.removeEventListener("click", ProductCardQtyHndlr);
        btn.addEventListener("click", ProductCardQtyHndlr);
    });

    subscriptionOptions.forEach(function (subscriptionOption) {
        subscriptionOption.removeEventListener("click", ProductCardSubscriptionOptionsHndlr);
        subscriptionOption.addEventListener("click", ProductCardSubscriptionOptionsHndlr);
    });

    btn.removeEventListener("click", ProductCardAddHndlr);
    btn.addEventListener("click", ProductCardAddHndlr);
}

function ProductCardQtyHndlr(e) {
    var el = e.currentTarget;
    var parent = el.parentNode;
    var input = parent.querySelector(".js-qty__num");

    if (el.classList.contains("quantity--minus")) {
        if (Number(input.value) > 1) {
            input.value = Number(input.value) - 1;
        }
    } else if (el.classList.contains("quantity--plus")) {
        input.value = Number(input.value) + 1;
    }

    // Create a new 'change' event
    var event = new Event('change');

    // Dispatch it.
    input.dispatchEvent(event);
}

function ProductCardSubscriptionOptionsHndlr(e) {
    var el = e.currentTarget;
    var parent = SearchParentsFor(el, "rc_product_card");
    var options = parent.querySelectorAll(".options-wrapper .option");
    var optionsContents = parent.querySelectorAll(".option-content--wrapper .option");
    var selectedOptionContent = parent.querySelector(".option-content--wrapper .option[id='" + el.getAttribute("data-sub-id") + "']");

    options.forEach(function (option) {
        option.classList.remove("option--active");
        option.querySelector("input").checked = false;
    });

    optionsContents.forEach(function (optionsContent) {
        optionsContent.classList.remove("option--active");
    });

    el.classList.add("option--active");
    selectedOptionContent.classList.add("option--active");
    el.querySelector("input").checked = true;

}

function ProductCardAddHndlr(e) {
    var el = e.currentTarget;
    var selectedSubscriptionType = GetSubscriptionTypeFromProduct(el);
    var post = GetPostDataForAddingSubscription(el, selectedSubscriptionType);

    el.innerText = "Adding...";
    SendRCAPIRequest(selectedSubscriptionType, "POST", "", post, function (err, response, xhr) {
        window.location.reload();
    });
}

function GetSubscriptionTypeFromProduct(el) {
    var parent = SearchParentsFor(el, "rc_product_card");
    var idx = parent.getAttribute('data-idx');
    var input = document.querySelector(".rc-container-wrapper input[name='selling_plan_" + idx + "']:checked");

    if (input.id.includes("subSave")) {
        return 'subscriptions';
    } else {
        return 'onetimes';
    }
}

function GetPostDataForAddingSubscription(el, purchaseType) {
    var parent = SearchParentsFor(el, "rc_product_card");
    var sellingPlanSelect = parent.querySelector(".selling_plan_groups");
    var sellingPlanOption = sellingPlanSelect.options[sellingPlanSelect.selectedIndex];
    var variantSelect = parent.querySelector(".product__variant--dropdown-select");
    var variantSelectOption = variantSelect.options[variantSelect.selectedIndex];
    var now = new Date();
    var qty = Number(parent.querySelector(".js-qty__num").value);
    var nextScheduleOut = window._rechargeSubscriptionData.schedule[0];
    var nextChargeDate = now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate();

    if (nextScheduleOut && nextScheduleOut.date) {
        nextChargeDate = nextScheduleOut.date.split("T")[0];
    }

    var post = {
        "address_id": window.ReCharge.Novum.hasOwnProperty('subscription') == true ? window.ReCharge.Novum.subscription.address_id : window.ReCharge.Novum.addresses[0].id,
        "quantity": qty,
        "external_product_id": parent.getAttribute("id"),
        "external_variant_id": variantSelect.value,
        "redirect_url": window.location.href
    };

    if (purchaseType == "subscriptions") {
        post.charge_interval_frequency = sellingPlanOption.getAttribute("data-order-interval-frequency");
        post.order_interval_frequency = sellingPlanOption.getAttribute("data-order-interval-frequency");
        post.order_interval_unit = sellingPlanOption.getAttribute("data-order-interval-unit");
        post.next_charge_scheduled_at = nextChargeDate;
    } else if (purchaseType == "onetimes") {
        post.price = variantSelectOption.getAttribute("data-price");
        post.product_title = variantSelectOption.getAttribute("data-product-title");
        post.add_to_next_charge = true;
    }

    console.log(post);

    return post;
}

function HandleSideBarPagination(evt, data, paginationType) {
    ReCharge.Novum.addMeta.next = data.meta.products.next;
    ReCharge.Novum.addMeta.previous = data.meta.products.previous;
    var next = document.querySelector("#te-modal-content .rct_pagination__container .rct_pagination__next");
    var prev = document.querySelector("#te-modal-content .rct_pagination__container .rct_pagination__prev");

    next.removeAttribute("onclick");
    prev.removeAttribute("onclick");
    next.addEventListener("click", function (e) {
        addProductHandlerV2(e, data.meta.products.next, "next");
    });

    prev.addEventListener("click", function (e) {
        addProductHandlerV2(e, data.meta.products.previous, "prev");
    });

    if (paginationType == "next") {
        ReCharge.Novum.Pagination.currentAddPage = ReCharge.Novum.Pagination.currentAddPage + 1;
    } else if (paginationType == "prev") {
        ReCharge.Novum.Pagination.currentAddPage = ReCharge.Novum.Pagination.currentAddPage - 1;
    }

    ReCharge.Novum.Pagination.updateButtonState('add');
    ReCharge.Novum.Pagination.updateCurrentPageNumber(ReCharge.Novum.Pagination.currentAddPage, 'add');

}

function ProductsAddSearch(ev) {
    console.log(ev);
    //Copied from searchProductsHandler _helpers.js but tweaked
    if (ev.keyCode === 13) {
        ev.preventDefault();

        var searchQuery = ev.target.value
            .trim()
            .toLowerCase()
            .replace(/"/g, '');
        var actionType = "add";

        var schema = ReCharge.Schemas.products.search(searchQuery, 6, 1, actionType);
        schemaStr = "&schema=" + encodeURIComponent(schema);

        SendRCAPIRequest("request_objects", "GET", schemaStr, null, function (err, response, xhr) {
            if (xhr && xhr.status == 200) {
                //to do: tidy this all up so that search, pagination and first rendering are all separate
                var productsToRender = response.products;
                //Copied from _scripts.js getProducts function. Looks like it does something before returning the product data
                ReCharge.Novum.Pagination.limit = 6;
                ReCharge.Novum.products = response.products;

                ReCharge.Novum.addMeta = response.meta.products;
                ReCharge.Novum.Pagination.limit = 6;

                delete window.locked;

                ReCharge.Novum.Pagination.currentAddPage = 1;
                ReCharge.Novum.Pagination.limit = 6;
                ReCharge.Novum.Pagination.type = 'add';
                RenderProductAddSidebar(productsToRender, "add");
                ReCharge.Novum.Pagination.renderInitialPagination();
            } else {
                console.log("Unable to get recharge products with error : " + JSON.stringify(err));
                console.log("Unable to get recharge products xhr : " + JSON.stringify(err));
            }
        });
    }
}

function ToggleUpcomingOrderDetails(e) {
    var el = e.currentTarget;
    var parent = SearchParentsFor(el, "next_order_details_wrapper");
    var toggleStatus = parent.getAttribute("data-toggle-status")

    if (toggleStatus == "closed") {
        parent.setAttribute("data-toggle-status", "open");
    } else if (toggleStatus == "open") {
        parent.setAttribute("data-toggle-status", "closed");
    }


}

function AddSubscriptionEventListeners() {
    // set up event handlers
    document.getElementById("recharge_v2_skip_next").addEventListener("click", HandleSkipNextOrder);
    document.getElementById("recharge_v2_order_now").addEventListener("click", HandleRenewNextOrderNow);
    document.getElementById("discount-accordion-button").addEventListener("click", ToggleDiscountAccordion);
    document.querySelector("#recharge-subscription-portal-v2 #discountSubmit").addEventListener("click", ApplyNextOrderDiscount);
    document.querySelector("#recharge-subscription-portal-v2 #editRenewalDateBtn span").addEventListener("click", ShowRenewalDatePicker);
    document.querySelector("#recharge-subscription-portal-v2 #editAddressBtn span").addEventListener("click", ToggleEditAddressForm);
    document.querySelector("#recharge-subscription-portal-v2 #editPaymentDetailsBtn span").addEventListener("click", HandlePaymentFormURL);
    document.querySelector("#recharge-subscription-portal-v2 #addressForm .submitBtn").addEventListener("click", function (e) {
        HandleChangeNextRenewalAddress(e);
    });
    document.querySelector("#recharge-subscription-portal-v2 #addressForm .cancelBtn").addEventListener("click", ToggleEditAddressForm);
    document.getElementById("all_product_yes_btn").addEventListener('click', function (e) {
        HandleChangeNextRenewalDate(e);
    });

    document.getElementById("all_product_select_btn").addEventListener('click', function (e) {
        HandleChangeNextRenewalDate(e);
    });

    document.getElementById("popup_close_btn").addEventListener('click', function (e) {
        document.querySelector(".select_product_list_popup").classList.add("hide");
    });

    document.querySelectorAll("#recharge-subscription-portal-v2 #discountRemove").forEach(function (item) {
        item.addEventListener("click", function (e) {
            RemoveNextOrderDiscount(e);
        });
    });
    document.querySelectorAll("#recharge-subscription-portal-v2 #subscription_cancel_btn").forEach(function (item) {
        item.addEventListener("click", function (e) {
            SearchParentsFor(e.currentTarget, "subscription-action__wrapper").querySelector("#product_remove_Popup").style.display = "flex";
        });

    });
    document.querySelectorAll("#recharge-subscription-portal-v2 #cancel_popup_close_btn").forEach(function (item) {
        item.addEventListener("click", function (e) {
            SearchParentsFor(e.currentTarget, "subscription-action__wrapper").querySelector("#product_remove_Popup").style.display = "none";
        });

    });
    document.querySelectorAll("#recharge-subscription-portal-v2 #subscription_cancel").forEach(function (item) {
        item.addEventListener("click", function (e) {
            CancelProductSubscription(e);
        });
    });
    document.querySelectorAll("#recharge-subscription-portal-v2 #onetime_cancel").forEach(function (item) {
        item.addEventListener("click", function (e) {
            CancelProductOnetime(e);
        });
    });
    document.querySelectorAll("#recharge-subscription-portal-v2 #subscription_skip").forEach(function (item) {
        item.addEventListener("click", function (e) {
            SkipProductSubscription(e);
        });
    });
    document.querySelectorAll("#recharge-subscription-portal-v2 #subscription_unskip").forEach(function (item) {
        item.addEventListener("click", function (e) {
            UnskipProductSubscription(e);
        });
    });
    document.querySelectorAll("#recharge-subscription-portal-v2 .freqDropdown").forEach(function (item) {
        item.addEventListener("change", function (e) {
            SearchParentsFor(e.currentTarget, "rc_subscription_info").querySelector("#save_subscription_btn").classList.remove("hide");
        });
    });
    document.querySelectorAll("#recharge-subscription-portal-v2 .quantity__input").forEach(function (item) {
        item.addEventListener("change", function (e) {
            SearchParentsFor(e.currentTarget, "rc_subscription_info").querySelector("#save_subscription_btn").classList.remove("hide");
        });
    });
    document.querySelectorAll("#recharge-subscription-portal-v2 #save_subscription_btn").forEach(function (item) {
        item.addEventListener("click", function (e) {
            HandleChangeSubscriptionDetails(e);
        });
    });
    document.querySelector("#recharge-subscription-portal-v2 #editRenewalDateBtn svg").addEventListener("click", function (e) {
        document.querySelector("#recharge-subscription-portal-v2 #renewalDateInput").classList.add("hide");
        document.querySelector("#recharge-subscription-portal-v2 #editRenewalDateBtn svg").classList.add("hide");
        document.querySelector("#recharge-subscription-portal-v2 #editRenewalDateBtn span").classList.remove("hide");
        document.querySelector(".manage__subscription_dates").classList.add("hide");
    });

    document.querySelector("#editNextOrderDetailsBtnMobile").addEventListener("click", ToggleUpcomingOrderDetails)

    var qtyButtons = document.querySelectorAll("#rc_subscription_card_element .product__quantity--wrapper button");
    qtyButtons.forEach(function (btn) {
        btn.removeEventListener("click", ProductCardQtyHndlr);
        btn.addEventListener("click", ProductCardQtyHndlr);
    });
}

function BuildViewFrame() {
    console.log("BUILDING SKELETON")
    var skeleton = `
     <div class="loading-overlay-wrapper hide" id="loading-overlay">
        <div class="subscription-loading-overlay"></div>
        <div class="loading-overlay-inner">
            <div class="loading-animation"></div>
            <div class="loading-text"><p>Saving changes</p></div>
        </div>
     </div>
     <div class="subscriptions_page--wrapper">
         <div class="rc_subscriptions_page_title">
             <h1 class="template--title"> Your Subscriptions </h1>
         </div>
         <div class="rc_active_subscriptions_wrapper">
             <div class="rc_active_subscriptions_left">
                 <div class="active-subscription__title--row">    
                     <h2 class="page-title"> Your Active Subscription </h2>
                 </div>
                 <div class="active-subscription__discount--row">
                    <h3 class="discount-header" id="discount-accordion-button"> Have a discount code? <i class="fa fa-chevron-down" aria-hidden="true"></i></h3>
                    <div class="active_subscription_discount_wrapper">
                        <div class="active-subscription__summary">
                            <div class="discount__wrapper">
                                <!-- <h4>Have a discount code?</h4> -->
                                <div class="discount-input--wrapper">
                                    <div class="discount-input-container">
                                        <input type="text" placeholder="enter code" id="discountString">
                                        <button id="discountSubmit">Apply</button>
                                    </div>
                                    <button id="discountRemove" class="hide">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="42.497" height="42.497" viewBox="0 0 42.497 42.497">
                                        <g id="Group_4893" data-name="Group 4893" transform="translate(21.248) rotate(45)">
                                            <circle id="Ellipse_10" data-name="Ellipse 10" cx="15.025" cy="15.025" r="15.025" fill="#80c8bd"></circle>
                                            <g id="Group_2909" data-name="Group 2909" transform="translate(9.563 9.563)">
                                            <line id="Line_30" data-name="Line 30" y2="10.925" transform="translate(5.462 0)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"></line>
                                            <line id="Line_31" data-name="Line 31" x1="10.925" transform="translate(0 5.462)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"></line>
                                            </g>
                                        </g>
                                        </svg>
                                    </button>
                                    <div class="applied-discounts--wrapper"></div>
                                </div>
                                <p class="smallprint hide">You've saved <span id="discountAmount" class="smallprint--highlight"></span>
                            </div>
                            <!-- <div class="summary-price__wrapper">
                                <h4>Total Price</h4>
                                <div class="price__window">
                                    <span id="fullPrice"></span> <span id="priceToPay"></span> <p class="smallprint hide"></p>
                            </div>
                            <div class="shipping-incentive-string hide" data-threshold={% raw %}{{ shop.metafields.custom_fields["free_shipping_threshold"] }}{% endraw %}>
                                <p class="smallprint hide" id="incentiveString">Spend another <span id="incentiveRemaining" class="smallprint--highlight"></span> and enjoy free shipping!</p>
                                <p class="smallprint hide" id="incentiveReachedString">Congratulations! You qualify for <span class="smallprint--highlight">free shipping!</span></p></div>
                            </div> -->
                        </div>
                    </div>
                 </div>

                 <div class="rc_subscription_card_element_wrapper rc_subscription_container">
                 </div>
             </div>
             <div class="rc_active_subscriptions_right">
                 <div class="flex-space-between-row active_subscriptions_buttons_container">

                     <button class="rc_btn border-light text-uppercase title-bold" onclick="addProductHandlerV2(event);">
                         Add product
                     </button>

                     <button class="rc_btn border-light text-uppercase title-bold" id="recharge_v2_order_now">
                        Order now
                     </button>

                     <button class="rc_btn border-light text-uppercase title-bold" id="recharge_v2_skip_next">
                        Skip order
                     </button>
                </div>

                <div class="active-order__details" id="activeOrderDetailsWrapper">
                    <div class="flex-space-between-row next_renewal_date_wrapper" id="nextRenewalDateWrapper">
                        <div class="flex-start-col">
                            <span class="renewalPrefix nextOrderPrefix" id="editRenewalDateBtnMobile">NEXT RENEWAL DATE</span>
                            <span class="nextOrderDetailsString" id="renewalDateString"></span>
                        </div>
                        <a class="editNextOrderBtn" id="editRenewalDateBtn">
                            <span>Edit</span>
                            <input type="date" id="renewalDateInput" class="hide">
                            <svg class="hide" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 42.497 42.497">
                                <g id="Group_4893" data-name="Group 4893" transform="translate(21.248) rotate(45)">
                                    <circle id="Ellipse_10" data-name="Ellipse 10" cx="15.025" cy="15.025" r="15.025" fill="#80c8bd"></circle>
                                    <g id="Group_2909" data-name="Group 2909" transform="translate(9.563 9.563)">
                                    <line id="Line_30" data-name="Line 30" y2="10.925" transform="translate(5.462 0)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"></line>
                                    <line id="Line_31" data-name="Line 31" x1="10.925" transform="translate(0 5.462)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"></line>
                                    </g>
                                </g>
                            </svg>
                        </a>
                    </div>
                    <div class="manage__subscription_dates hide">
                        <div class="flexbox">
                            <p class="description">Bring forwards delivery for all one-off and subscription products to this date</p>
                            <button id="all_product_yes_btn" class="rc_btn">Select All</button>
                        </div>
                        <div class="flexbox">
                            <p class="description">Select which items you'd like delivered. Please note future frequency will be set from this date</p>
                            <button id="all_product_select_btn" class="rc_btn">Select</button>
                        </div>
                    </div>
                    <div class="select_product_list_popup hide">

                        <div class="select_product_list_inner_wraper">
                        <button class="rc_btn save_btn btn-save-RC"> Save </button>
                        <span id="popup_close_btn">&#10005;</span>
                            <div class="select_product_list_inner">
                            
                            </div>
                            
                        </div>
                        
                    </div>
                    <div class="flex-space-between-row address__wrapper">
                        <div class="flex-start-col">
                              <span class="addressHeader nextOrderPrefix" id="editAddressBtnMobile">SHIPS TO</span>
                              <span class="nextOrderDetailsString" id="addressString"></span>
                        </div>
                        <a class="editNextOrderBtn" id="editAddressBtn">
                            <span>Edit</span>
                            <form class="addressForm_v2" id="addressForm">
                                <h1 style="font-size: 16px; margin: auto;">Edit Your Address</h1>
                                <input id="first_name" type="text" class="address_input_v2" placeholder="First Name *" required>
                                <input id="last_name" type="text" class="address_input_v2" placeholder="Last Name *" required>
                                <input id="address_one" type="text" class="address_input_v2" placeholder="Address line 1 *" required>
                                <input id="address_two" type="text" class="address_input_v2" placeholder="Address line 2">
                                <input id="province" type="text" class="address_input_v2" placeholder="County *" required>
                                <input id="zip" type="text" class="address_input_v2" placeholder="Post Code *" required>
                                <input id="city" type="text" class="address_input_v2" placeholder="City *" required>
                                <select id="country" name="country" class="address_input_v2 form-control" style="color: #a9a9a9; height: 35px; font-size: 10px !important" required>
                                <option value="" disabled selected hidden>United Kingdom *</option>
                                <option value="United Kingdom">United Kingdom</option>
                                </select>
                                <input id="phone" type="text" class="address_input_v2" placeholder="Phone *" required>
                                
                                <div class="address_input">
                                    <button class="submitBtn" onclick="event.preventDefault();">Submit</button>
                                    <button class="cancelBtn" onclick="event.preventDefault();">Cancel</button>
                                </div>
                            </form>
                        </a>
                    </div>

                    <div class="next_order_details_wrapper" id="nextOrderDetailsWrapper" data-toggle-status="closed">
                        <div class="flex-start-col">
                            <span class="renewalPrefix nextOrderPrefix" id="editNextOrderDetailsBtnMobile">UPCOMING ORDER DETAILS <i class="fa fa-chevron-down" aria-hidden="true"></i></span>
                            <span class="nextOrderDetailsString" id="nextOrderDetailsString"></span>
                        </div>

                        <div class="next-order-details-container">
                            <div class="nod-products"></div>
                            <div class="nod-details">
                                <div class="nod-order-row">
                                    <div class="nod-order-col nod-order-col-desc">
                                        <p>Date</p>
                                    </div>
                                    <div class="nod-order-col nod-order-col-data">
                                        <p data-nod-date></p>
                                    </div>
                                </div>                            
                                <div class="nod-order-row hide" data-nod-discount-row>
                                    <div class="nod-order-col nod-order-col-desc">
                                        <p>Discounts</p>
                                    </div>
                                    <div class="nod-order-col nod-order-col-data">
                                        <p data-nod-discounts></p>
                                    </div>
                                </div>
                                <div class="nod-order-row">
                                    <div class="nod-order-col nod-order-col-desc">
                                        <p>Subtotal</p>
                                    </div>
                                    <div class="nod-order-col nod-order-col-data">
                                        <p data-nod-sub-total-price></p>
                                    </div>
                                </div>
                                <div class="nod-order-row">
                                    <div class="nod-order-col nod-order-col-desc">
                                        <p>Shipping</p>
                                    </div>
                                    <div class="nod-order-col nod-order-col-data">
                                        <p data-nod-shipping></p>
                                    </div>
                                </div>
                            </div>
                            <div class="nod-total-details">
                                <div class="nod-order-row">
                                    <div class="nod-order-col nod-order-col-desc">
                                        <p>Total</p>
                                    </div>
                                    <div class="nod-order-col nod-order-col-data">
                                        <p data-nod-total-price></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="flex-space-between-row next_order_payment_wrapper" id="nextOrderPaymentWrapper">
                        <div class="flex-start-col">
                            <span class="nextOrderPaymentPrefix nextOrderPrefix" id="nextOrderPaymentBtnMobile">PAYMENT</span>
                            <span class="nextOrderDetailsString" id="nextOrderPaymentString"></span>
                        </div>
                        <a class="editNextOrderBtn" id="editPaymentDetailsBtn">
                            <span>Edit</span>
                        </a>
                    </div>
              </div>

        </div>
     </div>
    `;

    // TemplateReplace( skeleton, data );
    var wrapper = document.createElement("div");
    wrapper.setAttribute("id", "recharge-subscription-portal-v2");
    wrapper.innerHTML = skeleton;
    document.querySelector("#rc_te-template-wrapper").appendChild(wrapper);
}

function BuildSubscriptionStyles() {
    var style = `
    /************************ Lightning Subscriptions Css ************************/
    
    .product_remove_Popup_inner textarea {padding: 10px !important;}
    .flex-row-no-gap
    {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
    .flex-start-row
    {
        display: flex !important;
        flex-direction: row !important;
        justify-content: flex-start !important;
        align-items: center !important;
        gap: 0 20px !important;
        width: 100%;
    }
    .flex-space-between-row
    {
        display: flex !important;
        flex-direction: row !important;
        justify-content: space-between !important;
        align-items: center !important;
        gap: 0 20px !important;
        width: 100% !important;
    }
    .flex-start-col
    {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
    .rc_page-width.subscriptions_page--wrapper
    {
        padding: 40px 55px !important;
    }
    .rc_active_subscriptions_wrapper
    {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        border: solid 1px lightgrey;
        padding: 10px;
    }
    .rc_subscriptions_page_title h1
    {
        padding: 20px 0 !important;
    }
    .rc_active_subscriptions_left
    {
        border-right: solid 1px lightgrey;
        padding: 0 20px !important;
        margin: 20px 0 !important;
        width: 100%;
    }
    .rc_active_subscriptions_right
    {
        padding: 20px !important;
        width: 100%;
    }
    .active-subscription__title--row
    {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px !important;
    }
    .active-subscription__discount--row
    {
        margin-bottom: 20px !important;
    }
    .active-subscription__title--row .page-title,
    .active-subscription__discount--row .discount-header
    {
        color: grey !important;
        font-weight: 400 !important;
        font-size: 18px !important;
        font-family: var(--recharge-te-primary-font);
        flex-basis: unset !important;
        line-height: normal !important;
    }
    .active-subscription__discount--row .discount-header
    {
        cursor: pointer;
    }
    .rc_active_subscription_container
    {
        width: 100% !important;
    }
    .rc_subscription_container
    {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        width: 100% !important;
        padding: 0 !important;
    }
    .rc_subscription_card_element_wrapper
    {
        align-items: flex-start !important;
    }
    .rc_subscription_container .rc_photo_container img
    {
        max-width: 120px !important;
        max-height: 120px !important;
    }
    .rc_subscription_container .rc_subscription_info
    {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
    }
    .rc_subscription_container .subscription_badge
    {
        padding: 0 0 0 5px !important;
        text-transform: capitalize;
        font-family: var(--recharge-te-secondary-font)!important;
    }
    .rc_subscription_container .rc_order_title_container,
    .nextOrderPrefix
    {
        font-size: 20px !important;
        font-weight: 600 !important;
    }
    .rc_subscription_container .rc_order_price_details_container
    {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        gap: 0 10px !important;
    }
    .rc_subscription_container p.product__variant
    {
        font-weight: 400 !important;
        font-size: 18px !important;
        color: grey !important;
    }
    .rc_subscription_container p.subtotal__price
    {
        font-weight: 400 !important;
        font-size: 18px !important;
        color: #000 !important;
        font-family: var(--recharge-te-primary-font) !important;
    }
    .rc_subscription_container p.subtotal__price::before
    {
        content: unset !important;
    }
    .rc_subscription_container .product__quantity--wrapper p,
    .rc_subscription_container .frequency__wrapper span
    {
        font-size: 12px !important;
        font-weight: 400 !important;
        color: grey !important;
    }
    .rc_subscription_container .product__quantity--wrapper,
    .rc_subscription_container .frequency__wrapper
    {
        width: unset !important;
    }
    .rc_subscription_container .quantity__input,
    .rc_subscription_container .freqDropdown
    {
        background-color: #fff !important;
        border: solid 1px #000 !important;
        box-shadow: 1px 1px 3px !important;
        border-radius: 2px !important;
        padding: 10px !important;
    }
    .rc_subscription_container .quantity__input
    {
        max-width: 50px !important;
        font-size: 20px !important;
        padding: 5px !important;
        padding-right: 10px !important;
    }
    .rc_subscription_container .quantity__input::-webkit-inner-spin-button
    {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY( -50% );
        height: 30px;
        cusror: pointer !important;
    }
    .rc_subscription_container .freqDropdown
    {
        margin: 0 !important;
    }
    .rc_subscription_container .subscription-action__wrapper
    {
        gap: 0 !important;
    }
    textarea:focus-visible {
        outline: none;
    }
    
    .rc_subscription_container .subscription-action__wrapper button
    {
        background: transparent !important;
        color: gray !important;
        text-decoration: underline;
        font-weight: 400 !important;
        font-size: 13px !important;
        margin-top: 5px !important;
        text-transform: uppercase !important;
        font-family: var(--recharge-te-secondary-font) !important;
        padding: 5px !important;
        margin-left: 5px !important;
        width: fit-content !important;
    }
    body#recharge-novum #recharge-te p.error_message {
        color: red !important;
        font-size: 13px !important;
        margin-bottom: 15px !important;
    }
    body#recharge-novum #PageContainer #recharge-te #rc_te-template-wrapper .rc_btn.popup_btn {
        background: #025156 !important;
        color: #fff !important;
        text-decoration: none;
    }
    body#recharge-novum #PageContainer #recharge-te #rc_te-template-wrapper .rc_btn.popup_btn:hover {
      background: #fff !important;
      color: #025156 !important;
      border-color: #025156 !important;
    }  
    .rc_subscription_container .subscription-action__wrapper .product_remove_Popup_inner button{margin-left: 0 !important;}
    .rc_subscription_container .subscription-action__wrapper button: hover{
        background: #fff !important;
        color: #025156 !important;
        border: 1px solid #025156 !important;
    }  
    .active_subscriptions_buttons_container
    {
        margin-bottom: 20px !important;
    }
    .active_subscriptions_buttons_container button
    {
        font-size: 20px !important;
        padding: 20px 10px !important;
        width: 100% !important;
    }
    .nextOrderDetailsString
    {
        color: grey;
        font-family: var(--recharge-te-secondary-font) !important;
    }
    .editNextOrderBtn
    {
        position: relative;
    }
    .editNextOrderBtn span
    {
        color: deepskyblue !important;
        font-family: var(--recharge-te-secondary-font) !important;
        cursor: pointer;
    }
    .editNextOrderBtn svg
    {
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(50%,-50%);
    }
    #renewalDateInput
    {
        cursor: pointer;
    }
    .rc_order_price_details_container select
    {
        padding: 5px !important;
    }
    .summary-price__wrapper .price__window
    {
        justify-content: center !important;
    }
    .discount__wrapper #discountString
    {
        text-align: center;
    }
    .active_subscription_discount_wrapper
    {
        height: 0px;
        overflow: hidden;
        transition: all 0.5s ease;
    }
    .discount-input-container
    {
        width: 100% !important;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 20px;
    }
    .discount-input-container input
    {
        font-size: 16px !important;
    }
    .discount-input-container #discountString
    {
        width: 100% !important;
        text-align: left !important;
        border: solid 1px grey;
    }
    .discount-input-container #discountSubmit
    {
        margin: 0 !important;
        padding: 10px 25px !important;
        width: auto !important;
        font-size: 20px !important;
    }
    .applied-discounts--wrapper
    {
        margin: 0 0 0 20px !important;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 10px;
    }
    .applied-discount-code
    {
        padding: 15px 25px !important;
        background-color: #fff;
        color: #025156;
        border-radius: 8px;
        position: relative;
        border: solid 1px grey;
    }
    .applied-discount-code p
    {
        color: #025156 !important;
        font-size: 15px !important;
        margin: 0 !important;
    }
    .applied-discount-code #discountRemove
    {
        position: absolute !important;
        top: 0 !important;
        right: 0 !important;
        transform: translate( 40%, -40% ) !important;
        width: auto !important;
    }
    .applied-discount-code #discountRemove svg
    {
        width: 30px !important;
        height: 30px !important;
        border: solid 1px lightgrey;
        border-radius: 50%;
        background-color: #fff;
    }
    .applied-discount-code #discountRemove circle
    {
        fill: none !important;
    }
    .applied-discount-code #discountRemove line
    {
        stroke: #000 !important;

    }
    .discount__wrapper
    {
        width: 100% !important;
    }
    .discount__wrapper h4
    {
        margin-top: 0 !important;
    }
    #addressForm .address_input
    {
      padding-bottom: 50px !important;
    }
    #addressForm
    {
        position: fixed;
        right: -100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 300px;
        padding: 20px !important;
        gap: 0px;
        background-color: #f2f2f2;
        border-radius: 8px;
        flex-wrap: wrap;
        height: calc(100vh - 125px);
        top: 125px;
    }
    #addressForm input
    {
        width: 100%;
        line-height: normal;
        font-size: 10px !important;
    }
    #addressForm input::-webkit-input-placeholder
    {
        line-height: normal !important;
    }
    #addressForm .address_input
    {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        margin: 10px 0 !important;
        width: 100%;
        gap: 10px;
    }
    #addressForm .address_input button
    {
        background-color: #025156!important;
        color: #fff!important;
        padding: 10px 25px !important;
        border-radius: 8px;
        border: solid 2px transparent;
        width: 100%!important;
    }
    .active-subscription__summary
    {
        padding: 20px !important;
        background-color: #fff !important;
        border: 1px solid lightgrey !important;
        border-radius: 2px !important;
    }
    .discount-input--wrapper
    {
        flex-direction: row !important;
        align-items: flex-start !important;
    }
    #save_subscription_btn
    {
        background-color: #025156 !important;
        font-family: Sugarpunch !important;
        border: solid 2px transparent !important;
        border-radius: 8px !important;
        padding: 10px !important;
        white-space: nowrap !important;
        width: 100% !important;
        margin-top: 5px!important;
    }
    #save_subscription_btn span
    {
        color: #fff !important;
        font-size: 14px;
    }
    #loading-overlay.loading-overlay-wrapper
    {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
    }
    #loading-overlay .subscription-loading-overlay
    {
        background-color: #000;
        opacity: 0.3;
        z-index: 1;
        width: 100%;
        height: 100%;
        pointer-events: none;
    }
    #loading-overlay .loading-overlay-inner
    {
        background-color: lightgrey;
        z-index: 2;
        width: 25%;
        height: 25%;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 20px;
        border: solid 2px #000;
    }
    #loading-overlay .loading-animation
    {
        border: 10px solid #f3f3f3;
        border-radius: 50%;
        border-top: 10px solid grey;
        width: 80px;
        height: 80px;
        -webkit-animation: spin 2s linear infinite; /* Safari */
        animation: spin 2s linear infinite;
    }
    #loading-overlay .loading-text p
    {
        font-size: 18px !important;
    }
    .product__variant--dropdown-select
    {
        background-color: #f2f2f2 !important;
        border-radius: 8px !important;
        height: 55px !important;
        width: 100% !important;
        color: #025156;
        text-align: center;
        margin-bottom: 5px;
    }    
    .rc-container-wrapper
    {
        width: 100%;
        border: 1px solid #cacaca;
        border-radius: 3px;
        margin-bottom: 10px;
    }
    .rc-container-wrapper .option-content--wrapper
    {
        padding: 10px;
    }
    .selling_plan_groups
    {
        border: 1px solid #cacaca;
        width: 100%;
        border-radius: 4px;
        color: #025156;    
        margin: 0px !important;    
    }
    .product__button-wrapper
    {
        display: flex;
        flex-direction: row;
        gap: 0px 10px;
        align-items: center;        
    }
    .product__quantity--wrapper
    {
        border-radius: 8px;
        height: 65px;
        min-width: 150px;
        padding: 5px 5px !important;
        font-family: 'Sugarpunch';
        text-align: center;
        line-height: 1;
        font-size: 2.8rem;
        align-items: center;
        position: relative;
        display: flex;
        flex-basis: 50%;
        justify-content: center;        
    }

    .plus-center svg
    {
        top: 13px !important;
        left: 19px !important;
    }
    .quantity--minus
    {
        position: absolute;
        top: 50%;
        left: 16px;
        height: 40px;
        width: 40px !important;
        border-radius: 50% !important;
        padding-top: 0px !important;
        font-size: 18px;
        transform: translate(0%, -50%);
        background-color: #80C8BD !important;
        color: #fff;        
    }
    .js-qty__num
    {
        display: block;
        background: none;
        text-align: center;
        width: 100%;
        padding: 5px 20px !important;
        margin: 0 !important;
        height: 100% !important;
        border: none;
        background-color: #f2f2f2 !important;
        border-radius: 8px;        
    }
    .quantity--plus
    {
        position: absolute;
        top: 50%;
        right: 16px;
        height: 40px;
        width: 40px !important;
        border-radius: 50% !important;
        padding-top: 5px !important;
        font-size: 18px;
        transform: translate(0%, -50%);
        background-color: #80C8BD !important;
        color: #fff        
    }

    .quantity--minus svg
    {
        top: 50%;
        left: 50%;
        position: absolute;
        transform: translate(-50%);
        width: 12px;
    }

    .quantity--plus svg
    {
        top: 7px;
        left: 13px;
        position: absolute;
        transform: translate(-50%);
        width: 12px;
    }

    .product__button-wrapper .btn-section
    {
        background-color: #025156 !important;
        border: solid 2px transparent !important;
        color: #ffffff;
        border-radius: 14px !important;
        padding: 15px 10px !important;
        padding-top: 20px !important;
        line-height: 1;
        white-space: nowrap;   
        margin: 0px !important;     
    }

    #te-modal
    {
        z-index: 9999999 !important;
    }

    .rc-container-wrapper .options-wrapper
    {
        display: flex;
    }
    .rc-container-wrapper .options-wrapper .option.option--active
    {
        background-color: #fff;
    }
    .rc-container-wrapper .options-wrapper .option.option__subSave
    {
        width: 60%;
    }
    .rc-container-wrapper .options-wrapper .option.option__onetime
    {
        width: 40%;
    }    
    .rc-container-wrapper .options-wrapper .option
    {
        display: flex;
        align-items: center;
        padding: 5px !important;
        background-color: #f2f2f2;        
    }
    .rc-container-wrapper .options-wrapper .option input
    {
        width: 20px;
        height: 20px;
        accent-color: #000;
        margin-right: 5px !important;
        margin: 0 10px 0 0 !important;
        padding: 0 !important; 
    } 
    .rc-container-wrapper .options-wrapper .option label
    {
        font-size: 11px;
    }
    .rc-container-wrapper .options-wrapper .option label
    {
        margin-bottom: 0;
        font-weight: 500;
        color: #025156;        
    }
    .rc-container-wrapper .options-wrapper .option label span
    {
        color: #fdc572;        
    }    
    .rc-container-wrapper .option-content--wrapper .option
    {
        display: none;
    }   
    .rc-container-wrapper .option-content--wrapper .option.option--active
    {
        display: block;
    }
    .rc-container-wrapper .option-content--wrapper .option .onetime_option--content
    {
        display: flex;
        gap: 5px;        
        padding: 5px !important;
    }    
    .rc-container-wrapper .option-content--wrapper .option .text-content .message
    {
        font-size: 13px;
        margin-bottom: 0;        
    }
    .rc-container-wrapper .option-content--wrapper .option .text-content .message span
    {
        display: block;
        font-size: 10px;
        letter-spacing: .5px;
        font-weight: 400;
        color: #9a9a9a;        
    }

    [data-toggle-status='closed'] .next-order-details-container
    {
        display: none;
    }

    [data-toggle-status='open'] .next-order-details-container
    {
        display: block;
    }

    .next-order-details-container
    {
        width: 100%;
        border: 1px solid lightgrey;
        padding: 10px !important;
    }

    .next_order_details_wrapper
    {
        width: 100%;
    }

    .nod-order-row
    {
        width: 100%;
        margin-bottom: 10px !important;
    }
    .nod-order-col
    {
        display: inline-block;
        vertical-align: middle;
    }

    .nod-order-col-img
    {
        width: 75px;
        border: 1px solid lightgray;
        border-radius: 10px;        
    }

    .nod-order-col-img img
    {
       max-height: unset !important;
       max-width: unset !important;
       min-width: unset !important; 
       width: 100%;
    }

    .nod-order-col-body
    {
        width: calc( 100% - 150px );
        padding-left: 10px !important;
    }

    .nod-order-col-price
    {
        width: 75px;
        text-align: right;
    }

    .nod-details
    {
        border-top: 1px solid lightgrey;
        border-bottom: 1px solid lightgrey;
        padding-top: 10px !important;
    }

    .nod-details .nod-order-row .nod-order-col p
    {
        margin: 0px !important;
    }

    .nod-order-col-data
    {
        width: calc( 100% - 64px ); !important;
        text-align: right;
    }

    .nod-order-col-desc
    {
        width: 60px !important;
        text-align: left
    }
    .subscription_order_date
    {
        background-color: #fff;
        padding-left: 15px !important;     
        padding-top: 4px !important;   
    }
    .subscription_badge
    {
        line-height: normal;
    }
    body#recharge-novum #recharge-te #rc_te-template-wrapper .quantity__input
    {
        min-width: 120px !important;
        padding-left: 12px !important;  
        max-height: 42px !important;
    }
    body#recharge-novum #recharge-te #rc_te-template-wrapper .product__quantity--wrapper .quantity--minus
    {
        left: 36%;
        width: 25px !important;
        height: 25px;
    }
    body#recharge-novum #recharge-te #rc_te-template-wrapper .product__quantity--wrapper .quantity--plus
    {
        right: -10px;
        width: 25px !important;
        height: 25px;
    }
    
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
    }

    /* Firefox */
    input[type=number] {
    -moz-appearance: textfield;
    }
    .rc_subscription_container .quantity__input
    {
        padding-right: 10px;
        padding-left: 0px;
        min-width: 45px !important;

    }

    body#recharge-novum #recharge-te #rc_te-template-wrapper select, body#recharge-novum #recharge-te select
    {
        font-size: 16px;
    }
    .rc_active_subscriptions_right .manage__subscription_dates 
    {
        width: 100%;
    }
    .rc_active_subscriptions_right .manage__subscription_dates .flexbox
    {
        display: flex;
        justify-content: space-between;
        background: #CECECE;
        padding: 7px 10px 7px 10px!important;
        margin-bottom:5px !important;
        align-items: center;
    }
    body#recharge-novum #recharge-te #rc_te-template-wrapper .manage__subscription_dates .flexbox p.description,
    body#recharge-novum #recharge-te .manage__subscription_dates .flexbox p.description
    {
        margin-bottom: 0;
        font-family: var(--recharge-te-secondary-font) !important;
        font-size: 16px !important;
        line-height: 18px;
    }

    .rc_active_subscriptions_right .manage__subscription_dates .flexbox button
    {
        padding: 14px 35px 12px 35px!important;
        margin-left: 20px!important;
        max-width: 155px;
        width: 100% !important;
    }
    #product_remove_Popup
    {
        position: fixed;
        top: 0;
        left: 0;
        display:none;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.5);
        z-index: 999;
        justify-content: center;
        align-items: center;
    }
    #product_remove_Popup .product_remove_Popup_inner
    {
        background: #FFF;
        padding: 40px !important;
        position: relative !important;
        top: 0px;
        max-width: 500px;
        width: 100%;        
    }
    
    #product_remove_Popup .product_remove_Popup_inner #cancel_popup_close_btn
    {
        position: absolute;
        right: 20px;
        top: 8px;
        font-size: 20px;
        cursor: pointer;
    }
    #product_remove_Popup .product_remove_Popup_inner label
    {
        padding-bottom:12px !important;
    }
    #product_remove_Popup .product_remove_Popup_inner input
    {
        max-width: 300px;
        width: 100%;
        padding: 25px !important;
    }
    #product_remove_Popup .product_remove_Popup_inner input:focus
    {
        outline: auto !important;
        border: 1px solid !important;
        border-color: var(--colorBorder) !important;   
    }

    .select_product_list_popup
    {
        position: fixed;
        top: 0;
        left: 0;
        display:flex;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.5);
        z-index: 999;
        justify-content: center;
        align-items: center;
    }

    .select_product_list_popup .select_product_list_inner_wraper
    {
        background: #FFF;
        padding: 40px !important;
        position: relative !important;
        top: 100px;
    }
    .select_product_list_popup .select_product_list_inner
    {
        max-width: 500px;
        display: block;
        width: 100%;
        height: 500px;
        overflow-y: scroll;
    }
    .select_product_list_popup .select_product_list_inner .single_product 
    {
        padding: 10px !important;
        text-align: center;
    }
   
    .select_product_list_popup .select_product_list_inner .single_product .title_wraper h3
    {
        font-size: 15px !important;
        line-height: 16px !important;
        flex-basis: 100% !important;
        margin:0px !important;
        padding-left:5px !important;

    }
    .select_product_list_popup .select_product_list_inner .single_product .title_wraper
    {
        display: flex;
    }
    .select_product_list_popup .select_product_list_inner .single_product .title_wraper input
    {
        align-self: start;
    }

    .select_product_list_popup .select_product_list_inner_wraper .rc_btn.save_btn
    {
        float: right !important;
        padding: 12px 26px !important;
        margin-top: 20px !important;
        position: absolute;
        bottom: 20px;
        top: auto;
        right: 8px;
    }
    .select_product_list_popup .select_product_list_inner_wraper #popup_close_btn
    {
        top: 0;
        position: absolute;
        right: 12px;
        font-size: 24px;
        cursor: pointer;
    }
    
    @media only screen and (min-width: 768px) and (max-width: 1440px) {
        body#recharge-novum #recharge-te #rc_te-template-wrapper .subscriptions_quantity_frequency_wrapper {
            display: block !important;
        }
        body#recharge-novum #recharge-te #rc_te-template-wrapper select, body#recharge-novum #recharge-te select {
            // max-width: 120px;
        }
    }
 

    @media only screen and (max-width: 768px)
    {
        body#recharge-novum #recharge-te #rc_te-template-wrapper .product__quantity--wrapper .quantity--minus
        {
            left:10px;
        }
        body#recharge-novum #recharge-te #rc_te-template-wrapper .product__quantity--wrapper .quantity--plus
        {
            right: 30px;
        }
        .subscriptions_quantity_frequency_wrapper .product__quantity--wrapper p, .frequency__wrapper .deliveryString
        {
           display:none !important;
        }
        .product__quantity--wrapper .quantity_plus, .product__quantity--wrapper .quantity_minus
        {
            display: block;
        }
        .frequency__wrapper select
        {
            height: 55px !important;
        }
        .rc_subscription_container .quantity__input
        {
            padding-right: 8px !important;
            padding-left: 8px !important;
        }
 
        #addressForm
        {
            width: 100%;
        }
        .rc_active_subscriptions_wrapper
        {
            flex-direction: column-reverse !important;
            border: none !important;
        }
        .rc_subscription_card_element_wrapper
        {
            border-bottom: solid 1px lightgrey;
            box-shadow: unset !important;
            padding-bottom: 20px !important;
            flex-direction: column !important;
            align-items: center !important;
        }
        #recharge-te .nav--wrapper
        {
            display: none !important;
        }
        .rc_page-width.subscriptions_page--wrapper
        {
            padding: 40px 10px !important;
        }
        .active_subscriptions_buttons_container
        {
            flex-wrap: wrap !important;
        }
        .active_subscriptions_buttons_container button
        {
            margin-bottom: 10px !important
        }
        .discount-input--wrapper
        {
            flex-direction: column !important;
            gap: 20px 0 !important;
        }
        .applied-discounts--wrapper
        {
            margin: 0 !important;
        }
        .rc_subscription_container p.subtotal__price
        {
            margin: 0 !important;
        }
        .product__quantity--wrapper
        {
            flex-basis: 50% !important;
        }
        frequency__wrapper
        {
            flex-basis: 100% !important;
        }
        #rc_subscription_card_element
        {
            border-bottom: unset !important;
            border-radius: unset !important;
            padding-bottom: unset !important;
        }
        .rc_active_subscription_container
        {
            border-bottom: solid 1px lightgrey !important;
        }
        .rc_active_subscription_container:last-child
        {
            border-bottom: none !important;
        }
        .rc_subscription_card_element_wrapper
        {
            border: unset !important;
            border-radius: unset !important;
            padding-bottom: unset !important;
        }
        .rc_subscription_container .rc_subscription_info
        {
            width: 80% !important;
        }
        .rc_subscription_container .quantity__input
        {
            min-width: 140px !important;
        }
        #save_subscription_btn
        {
            margin: 0 !important;
        }
        .active-subscription__title--row .page-title
        {
            font-size: 26px !important;
            margin: 20px 0 !important;
            color: #000 !important;
        }
        .rc_active_subscriptions_right
        {
            border: solid 1px lightgrey;
            margin-bottom: 20px !important;
        }
        .rc_active_subscriptions_left
        {
            border: solid 1px lightgrey;
            padding: 20px !important;
        }
        .active-subscription__discount--row
        {
            border: none !important;
        }
    }
    
    @media only screen and (max-width: 480px)
    {
        .select_product_list_popup .select_product_list_inner
        {
            display: block;
        }
        .rc_active_subscriptions_right .manage__subscription_dates .flexbox
        {
            display: block;
        }
        .rc_active_subscriptions_right .manage__subscription_dates .flexbox .rc_btn
        {
            margin: 15px 0 0 0px !important;
        }
        body#recharge-novum #recharge-te #rc_te-template-wrapper .product__quantity--wrapper .quantity--minus
        {
         
        }
        body#recharge-novum #recharge-te #rc_te-template-wrapper .product__quantity--wrapper .quantity--plus
        {
       
            right: 15px;
        }
        
        body#recharge-novum #recharge-te #rc_te-template-wrapper .quantity__input
        {
            max-width: 105px !important;
            min-width: auto  !important;
        }
        .subscriptions_quantity_frequency_wrapper .product__button-wrapper
        {
            min-width: 100px!important;
        }
        .product__quantity--wrapper
        {
            min-width: 120px !important;
        }
        .rc_subscription_container .quantity__input
        {
            min-width: 100px !important;
        }
        body#recharge-novum #recharge-te #te-modal-content input[type="text"], body#recharge-novum #recharge-te #rc_te-template-wrapper select, body#recharge-novum #recharge-te select
        {
            min-width: 103px;
            padding: 0 10px !important;
            max-height: 42px !important;
        }
    }  
    `;
    var wrapper = document.createElement("style");
    wrapper.innerHTML = style;
    document.querySelector('#rc_te-template-wrapper').appendChild(wrapper);
}


function TryToShowNewView() {
    var hit = false;
    var domSelector = "#rc_te-template-wrapper .subscriptions_page--wrapper";
    var rcDOM = document.querySelector(domSelector);
    if (rcDOM) {
        rcDOM.setAttribute("style", "display: none;");
        BuildSubscriptionStyles();
        BuildViewFrame();
        hit = true;
    }
    return (hit);
}

function HideRechargeView() {
    if (!TryToShowNewView()) {
        var watch = document.querySelector("body");
        var observer = new MutationObserver(function (ml, o) {
            if (TryToShowNewView()) {
                observer.takeRecords();
                observer.disconnect();
            }
        });
        observer.observe(watch, {"childList": true, "subtree": true});
    }
}

function StartupRechargePortal() {
    if (window.location.pathname.toLowerCase().startsWith("/tools/recurring/portal")) {
        console.log("starting custom portal");
        if (window.location.pathname.toLowerCase().includes("/subscriptions")) {
            HideRechargeView();
            RefreshSubscriptionView();

        }
    }
}

StartupRechargePortal();

var subscriptionMessageEvent = false;
$('.template-product .product-single__form').on('DOMSubtreeModified', function () {
    if ($(".template-product .product-single__form .rc-container-wrapper .rc-option__onetime").length > 0 && $(".template-product .product-single__form .rc-container-wrapper input[type='radio']").length) {
        if (!subscriptionMessageEvent) {
            $(".template-product .product-single__form .rc-container-wrapper input[type='radio']").change(function () {
                if ($(this).val() == 'onetime') {
                    $(".onetime-subscription-message").removeClass('hide');
                } else {
                    $(".onetime-subscription-message").addClass('hide');
                }
            });
        }
    }
});
